/** PROTOTYPED */
const getLocale = () => ({
  "general": {
      "voltar": "Back",
      "abrirMenu": "Open menu",
      "procurar": "Search",
      "adicionar": "Add",
      "editar": "Edit",
      "informacoes": "Information",
      "buscar": "Search",
      "salvar": "Save",
      "duplicar": "Duplicate",
      "deletar": "Delete",
      "abrir": "Open",
      "salvarEdicao": "Save edition",
      "semDados": "No data registered",
      "semConexao": "Attention: there is no internet connection. The only functionality available is the registration of flight legs, available in the menu. All other functionality will fail.",
      "alertas": "Alerts",
      "desde": "Since",
      "pesquisar": "Find",
      "sim": "Yes",
      "nao": "No",
      "ambos": "Both",
      "consulta": "Query",
      "exportar": "Export",
      "exportarPDF": "Export PDF",
      "exportarXLS": "Export XLS",
      "exportarXLSX": "Export XLSX",
      "exportarTextoCSV": "Export CSV",
      "diaMesAno": "Mm/dd/yyyy",
      "mesAno": "Mm/yyyy",
      "horaMinuto": "Hh:mm",
      "diaMesAnoHoraMinuto": "Mm/dd/yyyy hh:mm",
      "recarregar": "Recharge",
      "importar": "Import",
      "justificar": "Justify",
      "atualizar": "To update",
      "filtrar": "Filter",
      "cancelar": "Cancel",
      "aberta": "Open",
      "expiracao": "Expiration",
      "realizada": "Carried out",
      "euro": "Euro",
      "dolar": "Dollar",
      "real": "Real",
      "mudarLinguagem": "Trocar para Português",
      "ingles": "English",
      "portugues": "Portuguese",   
      'offlineRefresh': "You are offline. System won't be properly refreshed. Are you sure you want to continue?",
    },
  "Calendario": {
      "Calendario": {
          "tabela": {
              "Domingo": "Sunday",
              "SegundaFeira": "Monday",
              "TercaFeira": "Tuesday",
              "QuartaFeira": "Wednesday",
              "QuintaFeira": "Thursday",
              "SextaFeira": "Friday",
              "Sabado": "Saturday"
          }
      }
  },
  "Controles": {
      "ExtratoMensalDePagamentosPorDataDeReferencia": {
          "opcoesTipos": {
              "Missao": "Mission",
              "Treinamento": "Training"
          },
          "opcoesMissao": {
              "Diarias": "Daily",
              "RepresentanteOperacional": "Operational Representative",
              "Transporte": "Transport",
              "Deslocamento": "Displacement",
              "Extra": "Extra"
          },
          "opcoesTreinamento": {
              "Diarias": "Daily",
              "Cheques": "Checks",
              "Extra": "Extra"
          },
          "titulo": "Monthly Payment Statement - By Reference Date",
          "botaoTutorial": "Tutorial",
          "paragrafoOControleExibeTodosOspagamentos": "The control displays all payments regardless of whether they are in the open listing or in any payment order",
          "paragrafoADataDeReferenciaParaAPesquisa": "The reference date for the search is the date of the pay schedule or training period",
          "formulario": {
              "Periodo": "Time course",
              "ExibirPagamentosAbertos": "View open payments"
          },
          "tabelaSaldos": {
              "semSaldoAnterior": "No previous balance found",
              "SaldoAnterior": "Previous balance"
          },
          "tabelaPagamentos": {
              "semPagamentos": "No payment found",
              "BaseOperacional": "Operating Base",
              "Periodo": "Time course",
              "TipoDeOrdem": "Order Type",
              "Treinamento": "Training",
              "CodigoDeControle": "Control Code",
              "Revisao": "Revision",
              "TipoDePagamento": "Type of payment",
              "Status": "Status",
              "Quantidade": "The amount",
              "ValorUnitario": "Unitary value",
              "ValorOriginal": "Original value",
              "Desconto": "Discount",
              "ValorRecebido": "Amount received",
              "Saldo": "Balance",
              "DataDoPagamento": "Pay day",
              "Acoes": "Actions"
          },
          "tabelaValores": {
              "semValores": "No consolidated value found",
              "ValorOriginal": "Original value",
              "Desconto": "Discount",
              "ValorRecebido": "Amount received",
              "Saldo": "Balance"
          },
          "tituloDiasDoPagamento": "Paydays",
          "tabelaDiasDoPagamento": {
              "Data": "Date",
              "Diarias": "Daily",
              "nenhumDiaEncontrado": "No days found. Certain information only started to be recorded from 05/2022"
          },
          "tituloDescontosRelacionados": "Related Discounts",
          "tabelaDescontosRelacionados": {
              "IdDoDebito": "Debit id",
              "ReferenciaDoDebito": "Debit reference",
              "ValorOriginalDoDebito": "Original debit amount",
              "ValorAmortizadoNoPagamento": "Amount amortized upon payment"
          },
          "tituloPagamentosRelacionados": "Related Payments",
          "tabelaPagamentosRelacionados": {
              "IdDoDebito": "Debit id",
              "ReferenciaDoPagamento": "Payment reference",
              "ValorOriginalDoDebito": "Original debit amount",
              "ValorAmortizadoNoPagamento": "Amount amortized upon payment"
          }
      },
      "ExtratoPagamentosPorPeriodoPorDataDePagamento": {
          "titulo": "Statement Payments by Period - By Payment Date",
          "paragrafoOControleExibeTodosOspagamentos": "The control displays all payments regardless of whether they are in the open listing or in any payment order",
          "paragrafoAsDatasDeReferenciaParaAPesquisa": "The reference dates for the search are the payment dates",
          "formulario": {
              "Inicio": "Start",
              "Termino": "End"
          },
          "tabelaPagamentos": {
              "semPagamentos": "No payment found",
              "BaseOperacional": "Operating Base",
              "Frota": "Fleet",
              "Periodo": "Time course",
              "TipoDeOrdem": "Order Type",
              "Treinamento": "Training",
              "CodigoDeControle": "Control Code",
              "Revisao": "Revision",
              "TipoDePagamento": "Type of payment",
              "Status": "Status",
              "Quantidade": "The amount",
              "ValorUnitario": "Unitary value",
              "ValorOriginal": "Original value",
              "Desconto": "Discount",
              "ValorRecebido": "Amount received",
              "Saldo": "Balance",
              "DataDoPagamento": "Pay day",
              "Acoes": "Actions"
          },
          "tituloDiasDoPagamento": "Paydays",
          "tabelaDiasDoPagamento": {
              "Data": "Date",
              "Diarias": "Daily",
              "nenhumDiaEncontrado": "No days found. Certain information only started to be recorded from 05/2022"
          },
          "tituloDescontosRelacionados": "Related Discounts",
          "tabelaDescontosRelacionados": {
              "IdDoDebito": "Debit id",
              "ReferenciaDoDebito": "Debit reference",
              "ValorOriginalDoDebito": "Original debit amount",
              "ValorAmortizadoNoPagamento": "Amount amortized upon payment"
          },
          "tituloPagamentosRelacionados": "Related Payments",
          "tabelaPagamentosRelacionados": {
              "IdDoDebito": "Debit id",
              "ReferenciaDoPagamento": "Payment reference",
              "ValorOriginalDoDebito": "Original debit amount",
              "ValorAmortizadoNoPagamento": "Amount amortized upon payment"
          }
      }
  },
  "EscalasDeTesteDeSonolencia": {
      "ListaDeEscalasDeTesteDeSonolencia": {
          "titulo": "List of drowsiness test scales",
          "botaoAdicionarEscala": "Add scale",
          "tabela": {
              "semEscalas": "There are no test scales registered",
              "ID": "ID",
              "Nome": "Name",
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "Acoes": "Actions"
          }
      },
      "AdicionarEscalaDeSonolencia": {
          "aguardeEnquantoAEscalaEGerada": "Please wait while the scale is generated. This process can take a few minutes.",
          "titulo": "Register drowsiness test scale",
          "formulario": {
              "Nome": "Name",
              "HorariosDeEnvio": "Shipping times",
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
              "Tripulantes": "Crew",
              "Mecanicos": "Mechanics",
              "Coordenadores": "Coordinators",
              "botaoAdicionarEscalaDeTeste": "Add test scale",
              "placeholder": {
                  "NomeDaEscalaDeSonolencia": "Sleepiness scale name",
                  "HorariosDeEnvio": "Hh:mm, separated by a comma.",
                  "SelecionarAplicabilidade": "Select applicability"
              }
          }
      },
      "EditarEscalaDeSonolencia": {
          "trocarStatusDaEscala": "Are you sure you would like to change the scale status?",
          "trocarStatusDaEscalaParaAprovado": "Are you sure you'd like to change the escalation status to approved?",
          "trocarStatusDaEscalaParaFinalizado": "Are you sure you'd like to change the status of the scale to finished?",
          "titulo": "Sleepiness scale editing",
          "botaoDeFichas": {
              "TrocarParaAprovado": "Switch to approved",
              "TrocarParaFinalizado": "Switch to finished"
          },
          "tabDadosDaEscala": {
              "tituloTab": "Scale data",
              "formulario": {
                  "Nome": "Name",
                  "DataInicial": "Initial date",
                  "DataFinal": "Final date",
                  "placeholder": {
                      "NomeDaEscalaDeSonolencia": "Sleepiness scale name"
                  }
              }
          },
          "tabTestesDeEscala": {
              "tituloTab": "Scale tests",
              "deletarColaboradorDaEscalaDeTeste": "Are you sure you'd like to delete this contributor from the roster of tests?",
              "tituloTestesDeEscalaDeSonolencia": "Sleepiness scale tests",
              "tabela": {
                  "semColaboradores": "There are no registered employees",
                  "ID": "ID",
                  "Colaborador": "Collaborator",
                  "ProgramacaoDeEnvio": "Shipping Schedule",
                  "Acoes": "Actions"
              },
              "tituloEditarTeste": "Edit test",
              "formulario": {
                  "Data": "Date",
                  "HorariosDeEnvio": "Shipping time",
                  "Colaborador": "Collaborator",
                  "placeholder": {
                      "HorariosDeEnvio": "Shipping time",
                      "SelecionarAplicabilidade": "Select applicability"
                  }
              }
          },
          "tabRelatorioFinal": {
              "tituloTab": "Final report",
              "formulario": {
                  "PeriodoDeJornada": "Working Period",
                  "DiasDeJornada": "Journey days",
                  "Bases": "Bases",
                  "Designacoes": "Designations",
                  "Funcoes": "Functions",
                  "Cargos": "Roles",
                  "Frotas": "Fleets",
                  "Grupos": "Groups",
                  "botaoProcurarRelatorios": "Browse reports",
                  "placeholder": {
                      "SelecionarPeriodoDeJornada": "Select journey periods",
                      "DiasDeJornada": "Days, separated by a comma. Ex.: 01, 02, 10, 11, etc.",
                      "SelecionarBases": "Select bases",
                      "SelecionarDesignacoes": "Select designations",
                      "SelecionarFuncoes": "Select functions",
                      "SelecionarCargos": "Select positions",
                      "SelecionarFrotas": "Select fleets",
                      "SelecionarGrupos": "Select groups"
                  }
              },
              "tituloPontosPorHorarioDeResposta": "Points for response time",
              "paragrafoPercentualDeAdesaoParcial": "Partial adherence percentage (to date)",
              "paragrafoPercentualDeAdesaoGlobal": "Global membership percentage",
              "paragrafoTempoMedioDeResposta": "Average response time",
              "paragrafoTotalRespostas": "Total responses",
              "tituloCadaHorarioDeResposta": "Every response time",
              "tabelaHorariosDeResposta": {
                  "PeriodoHoras": "Period hours",
                  "Total": "Total",
                  "Pontos": "Spots",
                  "Media": "Average"
              },
              "tituloPontosPorPeriodoDeJornada": "Points per journey period",
              "tabelaPontosPorPeriodoDeJornada": {
                  "PeriodoHoras": "Period hours",
                  "Total": "Total",
                  "Pontos": "Spots",
                  "Media": "Average"
              },
              "tituloPontosPorDiasDeJornada": "Points per journey day",
              "tabelaPontosPorDiasDeJornada": {
                  "PeriodoDias": "Period days",
                  "Total": "Total",
                  "Pontos": "Spots",
                  "Media": "Average"
              },
              "tituloBases": "Bases",
              "tabelaBases": {
                  "Base": "Base",
                  "Total": "Total",
                  "Pontos": "Spots",
                  "Media": "Average"
              },
              "tituloFuncoes": "Functions",
              "tabelaFuncoes": {
                  "Funcao": "Occupation",
                  "Total": "Total",
                  "Pontos": "Spots",
                  "Media": "Average"
              },
              "tituloGrupos": "Groups",
              "tabelaGrupos": {
                  "Grupo": "Group",
                  "Total": "Total",
                  "Pontos": "Spots",
                  "Media": "Average"
              },
              "tituloDesignacoes": "Designations",
              "tabelaDesignacoes": {
                  "Designacao": "Designation",
                  "Total": "Total",
                  "Pontos": "Spots",
                  "Media": "Average"
              },
              "tituloFrotas": "Fleets",
              "tabelaFrotas": {
                  "Frota": "Fleet",
                  "Total": "Total",
                  "Pontos": "Spots",
                  "Media": "Average"
              }
          }
      }
  },

  "TripulanteDeslocamentos": {
    "AdicionarDeslocamento": {
      "titulo": 'Add deslocation',
      "tituloAnteriores": 'Last deslocations',


      "formulario": {
        "houveDeslocamento": 'Houve deslocamento para sua apresentação no aeroporto',
        "tempoDeslocamento": 'Quanto tempo de deslocamento (inclui desde a saída de sua residência até a chegada no hotel ou aeroporto, o que tiver ocorrido primeiro)',
        "botaoSalvar": 'Save'
      },

      "tabela": {
        "dataApresentacao": 'Date of presentation',
        "houveDeslocamento": 'Has deslocation?',
        "tempoDeslocamento": 'Deslocation time',
        "Status": 'Status',
      },
    }
  },

  "TripulanteDiscrepancias": {
    "AdicionarDiscrepancia": {
      "titulo": 'Adicionar discrepância',
      "tituloAnteriores": 'Discrepâncias anteriores',

      "formulario": {
        "Data": 'Data',
        "Discrepancia": 'Discrepância',
        "grauEstresse": 'Grau de severidade/estresse',
        "botaoAdicionar": 'Adicionar'
      },

      "tabela": {
        "Data": 'Data',
        "Discrepancia": 'Discrepância',
        "grauEstresse": 'Grau de severidade/estresse',
      },
    }
  },

  
  "Fadigas": {
      "ListaDeFadigas": {
          "deletar": "Are you sure you'd like to delete this fatigue parameter?",
          "titulo": "List of fatigue parameters",
          "botaoAdicionarFadiga": "Add Fatigue",
          "tabela": {
              "semParametroDeFadiga": "There are no registered fatigue parameters",
              "ID": "ID",
              "Aplicabilidade": "Applicability",
              "Nome": "Name",
              "Tipo": "Type",
              "Operador": "Operator",
              "PontosPorHora": "PointsPerHour",
              "PontosPorQuantidade": "Points per quantity",
              "LimiteDePontos": "Point limit",
              "ObrigatorioPreenchimento": "Mandatory completion",
              "Acoes": "Actions"
          }
      },
      "AdicionarFadiga": {
          "titulo": "Register fatigue parameter",
          "formulario": {
              "Nome": "Name",
              "Tipo": "Type",
              "Operador": "Operator",
              "PontosPorHora": "Points per hour",
              "PontosPorQuantidade": "Points per quantity",
              "LimiteDePontos": "Point limit",
              "PontuacaoExtraPorHoraNoturna": "Extra Score for Night Time",
              "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
              "PontosAReduzirParaTreinamento": "Points to reduce for training",
              "ParametroObrigatorio": "Mandatory Parameter",
              "ParametroAutomatico": "Automatic parameter",
              "TipoDeAutomacao": "Automation type",
              "tituloAlertas": "Alerts",
              "LimiteMaximoDePontos": "Max points limit",
              "LimiteMinimoDePontos": "Minimum point limit",
              "LimiteDePontosDeHoraExtraPorSemana": "Limit of overtime points per week",
              "LimiteDePontosDeHoraExtraPorMes": "Limit of overtime points per month",
              "LimiteDeDiasComHoraExtraPorSemana": "Limit of overtime days per week",
              "LimiteDeDiasComHoraExtraPorMes": "Limit of days with overtime per month",
              "botaoAdicionarParametroDeFadiga": "Add fatigue parameter",
              "placeholder": {
                  "NomeDoParametroDeFadiga": "Fatigue parameter name",
                  "SelecionarTipo": "Select type",
                  "SelecionarOperador": "Select operator",
                  "QuantidadeDePontosPorHora": "Number of points per hour",
                  "QuantidadeDePontosPorQuantidade": "Number of points per amount",
                  "LimiteDePontosDoParametro": "Parameter point limit",
                  "PontuacaoExtraPorHoraNoturna": "Extra Score for Night Time",
                  "SelecionarAplicabilidade": "Select applicability",
                  "PontosAReduzirParaTreinamento": "Points to reduce for training",
                  "ParametroObrigatorio": "Mandatory Parameter",
                  "ParametroAutomatico": "Automatic parameter",
                  "LimiteMaximoDePontos": "Max points limit",
                  "LimiteMinimoDePontos": "Minimum point limit"
              }
          }
      },
      "EditarFadiga": {
          "deletar": "Are you sure you would like to delete this option?",
          "titulo": "Edit Fatigue Parameter",
          "formulario": {
              "Nome": "Name",
              "Tipo": "Type",
              "Operador": "Operator",
              "PontosPorHora": "Points per hour",
              "PontosPorQuantidade": "Points per quantity",
              "LimiteDePontos": "Point limit",
              "PontuacaoExtraPorHoraNoturna": "Extra Score for Night Time",
              "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
              "PontosAReduzirParaTreinamento": "Points to reduce for training",
              "ParametroObrigatorio": "Mandatory Parameter",
              "ParametroAutomatico": "Automatic parameter",
              "TipoDeAutomacao": "Automation type",
              "tituloAlertas": "Alerts",
              "LimiteMaximoDePontos": "Max points limit",
              "LimiteMinimoDePontos": "Minimum point limit",
              "LimiteDePontosDeHoraExtraPorSemana": "Limit of overtime points per week",
              "LimiteDePontosDeHoraExtraPorMes": "Limit of overtime points per month",
              "LimiteDeDiasComHoraExtraPorSemana": "Limit of overtime days per week",
              "LimiteDeDiasComHoraExtraPorMes": "Limit of days with overtime per month",
              "placeholder": {
                  "NomeDoParametroDeFadiga": "Fatigue parameter name",
                  "SelecionarCliente": "Select customer",
                  "QuantidadeDePontosPorHora": "Number of points per hour",
                  "QuantidadeDePontosPorQuantidade": "Number of points per amount",
                  "LimiteDePontosDoParametro": "Parameter point limit",
                  "PontuacaoExtraPorHoraNoturna": "Extra Score for Night Time",
                  "SelecionarAplicabilidade": "Select applicability",
                  "PontosAReduzirParaTreinamento": "Points to reduce for training",
                  "ParametroObrigatorio": "Mandatory Parameter",
                  "ParametroAutomatico": "Automatic parameter",
                  "SelecionarTipo": "Select type",
                  "LimiteMaximoDePontos": "Max points limit",
                  "LimiteMinimoDePontos": "Minimum point limit"
              }
          },
          "tituloAdicionarOpcoes": "Add options",
          "formularioAdicionarOpcoes": {
              "Nome": "Name",
              "Pontos": "Spots",
              "placeholder": {
                  "NomeDoParametroDeFadiga": "Fatigue parameter name",
                  "QuantidadeDePontos": "Amount of points"
              }
          },
          "tituloOpcoes": "Options",
          "tabela": {
              "Opcao": "Option",
              "Pontos": "Spots",
              "Acoes": "Actions"
          }
      }
  },
  "RelatoriosAuxiliaresFadiga": {
      "ProcurarRelatorioAuxiliar": {
          "titulo": "Statistics (FAPA)",
          "formulario": {
              "DataInicial": "Initial date",
              "DataFinal": "Final date"
          },
          "tituloResultadosDeAutoavaliacoes": "Self-Assessment Results",
          "tabela": {
              "semParametroDeFadiga": "There are no registered fatigue parameters",
              "ID": "ID",
              "Data": "Date",
              "Colaborador": "Collaborator",
              "Questao1": "Question 1",
              "Questao2": "Question 2",
              "Questao3": "Question 3",
              "Questao4": "Question 4",
              "PontuacaoFinal": "Final score"
          }
      },
      "AdicionarRelatorioAuxiliar": {
          "titulo": "Fatigue Self-Assessment Aid Tool (FAPA)",
          "formulario": {
              "tituloQuestao1QuaoAlertaVoceEsta": "Question 1: How alert do you think you are? (Consider your condition before taking the journey)",
              "tituloQuestao2VoceTeveSonoAdequado": "Question 2: Did you get adequate sleep?",
              "QuantoTempoDormiuNas24HorasAnteriores": "At the beginning of the journey, how long did you sleep in the previous 24 hours?",
              "QuantoTempoDormiuNas48HorasAnteriores": "At the beginning of the journey, how long did you sleep in the previous 48 hours?",
              "AoFimDaJornadaPorQuantasHorasTeraPermanicidoAcordado": "At the end of the scheduled journey, how many hours will you have remained awake, discounting any time allocated for rest in suitable accommodation or rest on board when composing an increased crew?",
              "tituloQuestao3QueHorasOcorreAPresenteJornada": "Question 3: What time does this journey take place?",
              "tituloQuestao4QualNivelDeRiscoOperacionalAssociado": "Question 4: What is the level of operational risk associated with the journey?",
              "Rota": "Route",
              "Opcoes": {
                  "Baixo": "Low",
                  "Moderado": "Moderate",
                  "Elevado": "High"
              },
              "Aeroportos": "Airports",
              "EspacoAereo": "Airspace",
              "NivelExperienciaTripulacao": "Crew Experience Level",
              "CaracteristicasEOperacionalidadeDaAeronave": "Aircraft characteristics and operability",
              "CondicoesAtmosfericas": "Atmosphere conditions",
              "botaoGerarAvaliacao": "Generate Assessment",
              "placeholder": {
                  "SelecioneUmaOpcao": "Select an option"
              }
          },
          "tituloQuestao1QuaoAlertaVoceEsta": "Question 1: How alert do you think you are? (Consider your condition before taking the journey)",
          "tituloQuestao2VoceTeveSonoAdequado": "Question 2: Did you get adequate sleep?",
          "QuantoTempoDormiuNas24HorasAnteriores": "At the beginning of the journey, how long did you sleep in the previous 24 hours?",
          "QuantoTempoDormiuNas48HorasAnteriores": "At the beginning of the journey, how long did you sleep in the previous 48 hours?",
          "AoFimDaJornadaPorQuantasHorasTeraPermanicidoAcordado": "At the end of the scheduled journey, how many hours will you have remained awake, discounting any time allocated for rest in suitable accommodation or rest on board when composing an increased crew?",
          "pontos": "Spots",
          "tituloQuestao3QueHorasOcorreAPresenteJornada": "Question 3: What time does this journey take place?",
          "tituloQuestao4QualNivelDeRiscoOperacionalAssociado": "Question 4: What is the level of operational risk associated with the journey?",
          "nota": "Note",
          "paragrafoSeORiscoElevadoEstiverPresenteInformarAoDespachoOperacional": "If Elevated Risk is present, it is recommended to consider risk controls such as napping, task rotation or informing the operational dispatch that you are not fit for duty.",
          "paragrafoPontuacao": "Punctuation",
          "paragrafoSeORiscoElevadoEstiverPresenteInformarAoOperador": "If Elevated Risk is present, it is recommended to consider risk controls such as napping, task rotation or informing the operator that you are not fit for duty.",
          "rota": "Route",
          "aeroportos": "Airports",
          "espacoAereo": "Airspace",
          "nivelExperienciaTripulacao": "Crew Experience Level",
          "caracteristicasEOperacionalidadeDaAeronave": "Aircraft characteristics and operability",
          "condicoesAtmosfericas": "Atmosphere conditions",
          "tituloResultadoDosRiscos": "Result of the risks",
          "paragrafoOrientacaoAoTripulante": "Crew Member Orientation",
          "paragrafoMecaONivelDeAlertaTripulacaoAumentada": "Measure the alert level using objective and subjective methods and discuss with your supervisor why your alert level may not be sufficient for this journey and consider being scheduled for another journey in order to manage the risk (e.g. in increased crew , longer rest period).",
          "paragrafoMecaONivelDeAlertaChochilo": "Measure alertness using objective and subjective methods, discuss with your supervisor whether your alertness level is adequate for this journey, and consider using additional mitigation strategies (eg nap, task rotation).",
          "paragrafoMecaONivelDeAlertaCafeina": "Measure alertness using both objective and subjective methods, discuss with your supervisor whether your alertness level is appropriate for this journey, and consider fatigue risk controls beneficial for this journey (e.g. use of caffeine, increased care with hydration and food)."
      }
  },
  "ReportesDeFadigas": {
      "ListaDeReportesDeFadigasAbertos": {
          "tituloMotivo": "Reason",
          "tituloObservacoes": "Comments",
          "botaoConfirmarVisualizacao": "Confirm view",
          "titulo": "List of Voluntary Fatigue Reports - Open",
          "tabela": {
              "semParametroDeFadiga": "There are no registered fatigue parameters",
              "ID": "ID",
              "Tripulante": "Crew member",
              "Data": "Date",
              "Acoes": "Actions"
          }
      },
      "ListaDeReportesDeFadigasFechados": {
          "tituloMotivo": "Reason",
          "tituloObservacoes": "Comments",
          "titulo": "List of Voluntary Fatigue Reports - Closed",
          "tabela": {
              "semParametroDeFadiga": "There are no registered fatigue parameters",
              "ID": "ID",
              "Tripulante": "Crew member",
              "Data": "Date",
              "Acoes": "Actions"
          }
      },
      "AdicionarReporteDeFadiga": {
          "titulo": "Voluntary fatigue report",
          "formulario": {
              "Motivo": "Reason",
              "Data": "Date",
              "OProblemaApresentadoPodeSerAlgoPontual": "Can the problem presented be considered punctual, that is, is it something that allows you to return to activities on the next mission day?",
              "Observacoes": "Comments",
              "botaoEnviarReporte": "Send report",
              "placeholder": {
                  "SelecionarMotivo": "Select reason",
                  "SelecionarOpcao": "Select option"
              }
          }
      },
      "EditarMotivosDeFadiga": {
          "deletar": "Are you sure you would like to delete this fatigue reason?",
          "titulo": "Edit Fatigue Reasons",
          "formulario": {
              "Nome": "Name",
              "placeholder": {
                  "NomeDoMotivoDeFadiga": "Fatigue reason name"
              }
          },
          "tituloMotivosDeFadigaCadastrados": "Registered reasons for fatigue",
          "tabela": {
              "Nome": "Name",
              "Acoes": "Actions"
          }
      }
  },
  "PesquisaDeRelatorios": {
      "titulo": "Report search",
      "formulario": {
          "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
          "Tripulantes135": "Crew - 135",
          "Tripulantes121": "Crew - 121",
          "Mecanicos": "Mechanics",
          "Coordenadores": "Coordinators",
          "DataInicial": "Initial date",
          "DataFinal": "Final date",
          "MotivoDoEnvio": "Reason for submission",
          "Respondido": "Answered",
          "botaoProcurarQuestionarios": "Browse surveys",
          "placeholder": {
              "SelecionarAplicabilidade": "Select applicability",
              "SelecionarTripulante": "Select crew member",
              "SelecionarMecanico": "Select mechanic",
              "SelecionarCoordenador": "Select coordinator",
              "SelecionarMotivos": "Select reasons",
              "SelecionarStatus": "Select status"
          }
      },
      "tituloListaDeQuestionarios": "List of questionnaires",
      "tabelaListaDeQuestionarios": {
          "semQuestionarios": "There are no registered questionnaires",
          "Data": "Date",
          "Colaborador": "Collaborator",
          "Status": "Status",
          "Motivo": "Reason",
          "Acoes": "Actions"
      },
      "tituloDadosDoQuestionarioDeFadiga": "Fatigue questionnaire data",
      "tituloBotaoResultadoDaPesquisa": "Search result",
      "tituloBotaoAltResultadoDeProva": "Test result",
      "botaoExportarCSV": "Export CSV",
      "tabelaDadosDoQuestionario": {
          "Pergunta": "Question",
          "Resposta": "Answer"
      }
  },
  "RelatorioAbastecimento": {
      "ListaDeAbastecimentos": {
          "lista": "Refuels list",
          "adicionar": "Add refuel",
          "editar": "Edit refuel",
          "deletar": "Delete refuel",
          "tabela": {
            "Data": "Date",
            "Relatório": "Flight Report Nº",
            "Voo": "Flight N°",
            "Aeronave": "Aircraft",
            "Fornecedor": "Supplier",
            "Localidade": "Location",
            "Quantidade": "Quantity",
            "Acoes": "Actions",
          },
        },
        "EditarAbastecimento": {
          "titulo": "Edit refuel",
          "dados": "Data",
          "formulario": {
              "AnexarNotaFiscal": "Attach invoice",
              "Aeronave": "Aircraft",
              "Empresa": "Company",
              "Relatorio": "Report",
              "CombustivelSolicitado": "Fuel Requested (Kg or Lb)",
              "NumeroDaCe": "EC number",
              "Trecho": "Flight Leg",
              "Fornecedor": "Provider",
              "CombustivelAbastecido": "Fuel supplied (L)",
              "Localidade": "Location",
              "Comandante": "Captain",
              "VendidoPara": "Sold to",
              "Endereco": "Address",
              "Tipo": "Type",
              "Reg": "Register",
              "Capt": "Captain",
              "InicioAbastecimento": "Refuel start",
              "Click": "Click",
              "TerminoAbastecimento": "Refuel finish",
              "ProximaLocalidade": "Next location",
              "NumeroHidrante": "Hydrant number",
              "SeuNumeroDeVenda": "Your sales number",
              "NumeroDeVendaAnterior": "Previous sale number",
              "LeituraInicial": "Initial reading",
              "LeituraFinal": "Final reading",
              "Entregues": "Delivered",
              "TipoCombustivel": "Type of fuel",
              "Preco": "Price.",
              "Quantidade": "Quantity",
              "ValorUnitario": "Unitary valie",
              "ValorTotal": "Total value",
              "ValorReembolsavel": "Refundable value",
              "ValorFinal": "Final value",
              "botaoEditarAbastecimento": "Edit refuel",
              "placeholder": {
                  "SelecioneAeronave": "Select the aircraft",
                  "SelecioneRelatorio": "Select the report",
                  "SelecioneTrecho": "Select the leg",
                  "SelecioneFornecedor": "Select fuel supplier",
                  "SelecioneLocal": "Select location"
              }
          },
          "aprovacoes": {
              "titulo": "Approvals",
              "tabela": {
                "Tipo": "Type",
                "Aprovacao": "Approval",
                "Acoes": "Actions",
              },
              "modalReprovar": {
                "Titulo": "Reprove",
                "TituloPorLogin": "Reprove with Login",
                "TituloPorAssinatura": "Reprove with e-signature",
                "Razao": "Reproval justification",
                "BotaoReprovar": "Reprove refuel",
                "Confirmacao": "Are you sure you want to reprove this refuel?",
                "AlertaAssinaturaVazia": "You have to sign before approving",
      
              },
              "modalAprovar": {
                "Titulo": "Approve",
                "TituloPorLogin": "Approve with Login",
                "TituloPorAssinatura": "Approve with e-signature",
                "BotaoAprovar": "Approve refuel",
                "Confirmacao": "Are you sure you want to approve this refuel?",
                "AlertaAssinaturaVazia": "You have to sign before approving",
              }
            }
        },
      "AdicionarAbastecimento": {
          "deletar": "Are you sure you want to delete this refuel?",
          "titulo": "Register refuel",
          "formulario": {
              "AnexarNotaFiscal": "Attach invoice",
              "Aeronave": "Aircraft",
              "Empresa": "Company",
              "Relatorio": "Report",
              "CombustivelSolicitado": "Fuel Requested (Kg or Lb)",
              "NumeroDaCe": "EC number",
              "Trecho": "Flight Leg",
              "Fornecedor": "Provider",
              "CombustivelAbastecido": "Fuel supplied (L)",
              "Localidade": "Location",
              "Comandante": "Captain",
              "VendidoPara": "Sold to",
              "Endereco": "Address",
              "Tipo": "Type",
              "Reg": "Register",
              "Capt": "Captain",
              "InicioAbastecimento": "Refuel start",
              "Click": "Click",
              "TerminoAbastecimento": "Refuel finish",
              "ProximaLocalidade": "Next location",
              "NumeroHidrante": "Hydrant number",
              "SeuNumeroDeVenda": "Your sales number",
              "NumeroDeVendaAnterior": "Previous sale number",
              "LeituraInicial": "Initial reading",
              "LeituraFinal": "Final reading",
              "Entregues": "Delivered",
              "TipoCombustivel": "Type of fuel",
              "Preco": "Price",
              "Quantidade": "Amount",
              "ValorTotal": "Total",
              "botaoAdicionarAbastecimento": "Add refuel",
              "placeholder": {
                  "SelecioneAeronave": "Select the aircraft",
                  "SelecioneRelatorio": "Select the report",
                  "SelecioneTrecho": "Select the leg",
                  "SelecioneFornecedor": "Select fuel supplier",
                  "SelecioneLocal": "Select location"
              }
          },
          "tabela": {
              "Trecho": "Flight Leg",
              "NumeroDaCe": "EC No.",
              "Fornecedor": "Provider",
              "Localidade": "Location",
              "QuantidadeSolicitada": "Quantity requested",
              "QuantidadeAbastecida": "Quantity supplied",
              "Acoes": "Actions"
          },
          "modalEditarAbastecimento": {
              "titulo": "Edit fuel request",
              "formulario": {
                  "CombustivelSolicitado": "Fuel Requested (Kg or Lb)",
                  "NumeroDaCe": "EC number",
                  "Trecho": "Flight Leg",
                  "Fornecedor": "Provider",
                  "CombustivelAbastecido": "Fuel supplied (L)",
                  "Localidade": "Location",
                  "botaoEditarAbastecimento": "Edit refuel"
              }
          }
      }
  },
  "RelatoriosDeVoo": {
      "ListaDeRelatoriosDeVoo": {
          "titulo": "Flight reports",
          "tituloOffLine": "Flight reports - Offline",
          "botaoAdicionarRelatorioDeVoo": "Add flight report",
          "formulario": {
              "botaoMudarData": "Change date"
          },
          "tabela": {
              "semRelatorios": "There are no registered reports",
              "NumeroDoRelatorio": "Report number",
              "ID": "ID",
              "Base": "Base",
              "Data": "Date",
              "Aeronave": "Aircraft",
              "Frota": "Fleet",
              "Cliente": "Client",
              "TipoDeVoo": "Type of flight",
              "NumeroDoVoo": "Flight number",
              "Status": "Status",
              "Acoes": "Actions"
          }
      },
      "AdicionarRelatorioDeVoo": {
          "titulo": "Register new flight report",
          "formulario": {
              "Data": "Date",
              "Prefixo": "Prefix",
              "Voo": "Flight",
              "NumeroDeVoo": "Flight number",
              "NumeroDoRelatorio": "Flight report number",
              "SolicitouIsencao": "Requested exemption",
              "Base": "Base",
              "Contrato": "Contract",
              "MecanicoResponsavel": "Responsible mechanic",
              "Cliente": "Client",
              "Observacoes": "Comments",
              "botaoCriarRelatorioDeVoo": "Create flight report"
          }
      },
      "EditarRelatoriosDeVoo": {
          "trocarStatusDoRelatorioDeVoo": "Are you sure you would like to change the flight report status?",
          "confirmarSalvarTodos": "Are you sure you would like to save all legs?",
          "infoOffline": "System offline. Wait for connection and try again.",
          "mensagemOfflineSemVoo": "This flight report wasn't registered offline and can't be edited.",

          "titulo": "Edit flight report",
          "botaoRelatorio": "Report",
          "botaoExtratoDB": "DB extract",
          "botaoXML": "XML",
          "botaoRelatorioDeVoo": {
              "TrocarParaRascunho": "Switch to draft",
              "TrocarParaFinalizado": "Switch to finished",
              "TrocarParaCancelado": "Switch to Canceled"
          },
          "erros": "The following filling errors prevented the report from being finalized",
          "erros_salvar": "The following filling errors prevented the leg(s) from being saved",
          
          "modalDiscrepanciaHorarios": {
              "titulo": "Discrepancy of times filled in the sections with those received from Flight Following",
              "substituir": "Are you sure you'd like to replace the leg times with those of Flight Following?",
              "substituirTodos": "Are you sure you'd like to replace the times for all legs with those for Flight Following?",
              "botaoSubstituir": "Replace",
              "botaoSubstituirTodos": "Replace all times with those from Flight Following",
              "ignorar": "Are you sure you'd like to keep the leg times and ignore the Flight Following ones?",
              "ignorarTodos": "Are you sure you'd like to keep the times for all legs and ignore those for Flight Following?",
              "botaoIgnorar": "Ignore",
              "botaoIgnorarTodos": "Ignore all Flight Following times and keep those filled in",
              "tabela": {
                "ID": "ID",
                "Trecho": "Flight Leg",
                "FlightFollowing": "Flight Following",
                "Preenchido": "Filled",
                "Partida": "Departure",
                "Decolagem": "Take off",
                "Pouso": "Landing",
                "Corte": "Cut",
                "Acoes": "Actions",
                "botaoSubstituir": "To replace",
                "botaoIgnorar": "Ignore"
                }
          },
          "formularioEditarRelatorio": {
              "Data": "Date",
              "Prefixo": "Prefix",
              "Voo": "Flight",
              "NumeroDeVoo": "Flight number",
              "NumeroDoRelatorio": "Flight report number",
              "SolicitouIsencao": "Requested exemption",
              "Base": "Base",
              "Contrato": "Contract",
              "MecanicoResponsavel": "Responsible mechanic",
              "Cliente": "Client",
              "Observacoes": "Comments",
              "botaoEditarRelatorioDeVoo": "Edit flight report"
          },
          "tabelaVoosDia": {
            "Titulo": "Other flights for the day",
            "SemVoos": "No other flights for the day",
            "Id": "Id",
            "NumeroVoo": "Flight No.",
            "NumeroRelatório": "Flight Report No.",
            "DecolagemPrevista": "Scheduled departure",
            "Origem": "Origin",
            "Cliente": "Client",
            "Contrato": "Contract",
            "TipoVoo": "Flight Type",
            "Status": "Status",
          },
          "excluirTripulante": "Are you sure you want to delete this crew member? It will be deleted from all legs.",
          "tituloCadastrarTripulacao": "Register crew",
          "formularioCadastrarTripulacao": {
              "Tripulante": "Crew member",
              "FuncaoDeBordo": "On-board function",
              "DataDeApresentacao": "Date of the presentation",
              "HoraDeApresentacao": "Presentation time",
              "botaoAdicionarTripulante": "Add crew member"
          },
          "tituloTripulantesCadastrados": "Registered crew",
          "tabelaTripulantesCadastrados": {
              "Nome": "Name",
              "CANAC": "CANAC",
              "SISPAT": "SISPAT",
              "FB": "FB",
              "Apresentacao": "Presentation",
              "DecolagemPouso": "Takeoff/Landing",
              "TempoTotal": "Total time",
              "Navegacao": "Navigation",
              "Instrumento": "Instrument",
              "Noturno": "Night",
              "PousosDiurnos": "Day Landings",
              "PousosNoturnos": "Night Landings",
              "Pax": "Pax.",
              "Carga": "Payload",
              "Consumo": "Consumption",
              "LongLine": "Long line",
              "ShortLine": "Short line",
              "Acoes": "Actions"
          },
          "tituloCadastrarTrecho": "Register leg",
          "botaoSalvarTodos": "Edit all legs",
          "formularioCadastrarTrecho": {
              "Origem": "From",
              "Destino": "To",
              "Partida": "Start",
              "DEC": "Takeoff",
              "POU": "Landing",
              "Corte": "Shutdown",
              "DECPOU": "Tkof-Land",
              "Total": "Total",
              "Nav": "Nav.",
              "IFR": "IFR",
              "Noturno": "Night",
              "Diurnos": "Day",
              "Noturnos": "Night",
              "Partidas": "Starts",
              "PAX": "PAX",
              "Carga": "Payload",
              "LongLine": "Long line",
              "ShortLine": "Short line",
              "Inicial": "Initial",
              "Final": "Final",
              "CodigoPTBR": "PTBR code",
              "botaoAdicionarTrecho": "Add leg"
          },
          "tabelaCadastrarTrecho": {
              "Realizados": "Performed",
              "Pousos": "Landings",
              "Dados": "Data",
              "CargaExterna": "External load",
              "Combustivel": "Fuel",
              "OperacaoPTBR": "PTBR operation",
              "Acoes": "Actions",
              "Numero": "No.",
              "Origem": "From",
              "Destino": "To",
              "Partida": "Start",
              "DEC": "Takeoff",
              "POU": "Landing",
              "Corte": "Shutdown",
              "DECPOU": "Tkof-Land",
              "Total": "Total",
              "Nav": "Nav.",
              "IFR": "IFR",
              "Noturno": "Night",
              "Diurnos": "Day",
              "Noturnos": "Night",
              "Partidas": "Starts",
              "PAX": "PAX",
              "Carga": "Payload",
              "LongLine": "Long line",
              "ShortLine": "Short line",
              "Inicial": "Initial",
              "Final": "Final",
              "CodigoPTBR": "PTBR code"
          },
          "tituloTotaisDosTrechos": "Total legs",
          "tabelaTotaisDosTrechos": {
              "DecolagemPouso": "Takeoff/Landing",
              "TempoTotal": "Total time",
              "Navegacao": "Navigation",
              "Instrumento": "Instrument",
              "Noturno": "Night",
              "PousosDiurnos": "Day Landings",
              "PousosNoturnos": "Night Landings",
              "Pax": "Pax.",
              "Carga": "Payload",
              "Consumo": "Consumption"
          },
          "excluirTrecho": "Are you sure you want to delete this leg?",
          "removerTripulanteDoTrecho": "Are you sure you'd like to remove this crew member from this leg?",
          "tituloEdicaoTrecho": "Edit leg",
          "formularioEditarTrecho": {
              "Origem": "From",
              "Destino": "To",
              "Partida": "Start",
              "DEC": "Takeoff",
              "POU": "Landing",
              "Corte": "Shutdown",
              "DECPOU": "Tkof-Land",
              "Total": "Total",
              "Nav": "Nav.",
              "IFR": "IFR",
              "Noturno": "Night",
              "Diurnos": "Day",
              "Noturnos": "Night",
              "Partidas": "Starts",
              "PAX": "PAX",
              "Carga": "Payload",
              "LongLine": "Long line",
              "ShortLine": "Short line",
              "Inicial": "Initial",
              "Final": "Final",
              "CodigoPTBR": "PTBR code",
              "Horario": "Schedule",
              "Copiar": "Copy",
              "Atual": "Current",
              "Following": "F. Follow",
              "FollowingShort": "Follow",
              "botaoEditarTrecho": "Edit leg",
              "limparTrecho": "The leg data was deleted."
          },
          "tituloTripulacaoCadastrada": "Registered crew",
          "formularioAdicionarTripulante": {
              "Tripulante": "Crew member",
              "FuncaoDeBordo": "Role",
              "botaoAdicionarTripulante": "Add crew member"
          },
          "tabelaTripulantes": {
              "Nome": "Name",
              "FuncaoDeBordo": "Role",
              "Acoes": "Actions"
          },
          "excluirAbastecimento": "Are you sure you want to delete this refuel?",
          "mensagemDadosAtualizadosComSucesso": "Data updated successfully",
          "tituloCadastrarAbastecimento": "Register refuel",
          "formularioAdicionarAbastecimento": {
              "CombustivelSolicitado": "Fuel Requested (Kg or Lb)",
              "Trecho": "Leg",
              "NumeroDaCE": "EC number",
              "Fornecedor": "Provider",
              "CombustivelAbastecido": "Fuel supplied (L)",
              "Localidade": "Location",
              "botaoAdicionarAbastecimento": "Add refuel"
          },
          "tituloAbastecimentosCadastrados": "Registered supplies",
          "tabelaAbastecimentosCadastrados": {
              "Trecho": "Flight Leg",
              "NumeroDaCE": "EC No.",
              "Cia": "Co.",
              "QuantidadeSolicitada": "Quantity requested",
              "QuantidadeAbastecida": "Quantity supplied",
              "Acoes": "Actions"
          },
          "tituloEditarSolicitacaoDeCombustivel": "Edit fuel request",
          "formularioEditarSolicitacaoDeCombustivel": {
              "CombustivelSolicitado": "Fuel Requested",
              "Trecho": "Flight Leg",
              "NumeroDaCE": "EC number",
              "Fornecedor": "Provider",
              "CombustivelAbastecido": "Fuel supplied (L)",
              "Localidade": "Location",
              "botaoEditarAbastecimento": "Edit refuel"
          },
          "tituloObservacoes": "Comments",
          "formularioEditarObservacoes": {
              "Observacoes": "Comments",
              "botaoEditarObservacoes": "Edit notes"
          },
          "tituloAlertasDoRelatorio": "Report Alerts",
          "tabelaAlertasDoRelatorio": {
              "Mensagem": "Message",
              "Data": "Date"
          },
          "aprovarRelatorio": "Are you sure you want to approve this report?",
          "reabrirRelatorio": "Are you sure you want to reopen this report?",
          "reprovarRelatorio": "Are you sure you want to disapprove this report?",
          "relatorioReabertoGerouImplicacoes": "This report has been reopened! This led to the following implications",
          "tabelaImplicacoes": {
              "Mensagem": "Message",
              "Data": "Date"
          },
          "tituloAprovacoes": "Approvals",
          "botaoReabrirRelatorio": "Reopen report",
          "tabelaAprovacoes": {
              "Tipo": "Type",
              "Tripulante": "Crew member",
              "Aprovacao": "Approval",
              "Acoes": "Actions"
          },
          "tituloJustificativaReprovacao": "Justification for disapproval",
          "formularioReprovacao": {
              "RazaoDaReprovacao": "Reason for disapproval",
              "botaoReprovarRelatorio": "Fail report"
          },
          "tituloLoginDoComandanteNoLDAP": "Commander login in LDAP",
          "formularioLogin": {
              "botaoAcessarSistema": "Access the system",
              "placeholder": {
                  "Email": "Your email",
                  "Senha": "Your password"
              }
          },
          "tituloLogDoRelatorio": "Report log",
          "tabelaLogRelatorio": {
              "Usuario": "User",
              "Acao": "Action",
              "Descricao": "Description",
              "Data": "Date"
          }
      },
      "ListaDeRelatoriosDeVooOffline": {
          "titulo": "Flight reports",
          "tabela": {
              "semRelatorios": "There are no registered reports",
              "ID": "ID",
              "NumeroDoRelatorio": "Report number",
              "Base": "Base",
              "Data": "Date",
              "Aeronave": "Aircraft",
              "Frota": "Fleet",
              "Cliente": "Client",
              "TipoDeVoo": "Type of flight",
              "NumeroDoVoo": "Flight number",
              "Status": "Status",
              "Acoes": "Actions"
          }
      },
      "EditarRelatoriosDeVooOffline": {
          "trocarStatusDoRelatorioDeVoo": "Are you sure you would like to change the flight report status?",
          "confirmarSalvarTodos": "Are you sure you would like to save all legs?",
          "titulo": "Edit flight report",
          "botaoRelatorio": "Report",
          "botaoExtratoDB": "DB extract",
          "botaoXML": "XML",
          "botaoRelatorioDeVoo": {
              "TrocarParaRascunho": "Switch to draft",
              "TrocarParaFinalizado": "Switch to finished",
              "TrocarParaCancelado": "Switch to canceled"
          },
          "erros": "The following filling errors prevented the report from being finalized",
          "formularioEditarRelatorio": {
              "Data": "Date",
              "Prefixo": "Prefix",
              "Voo": "Flight",
              "NumeroDeVoo": "Flight number",
              "NumeroDoRelatorio": "Flight report number",
              "SolicitouIsencao": "Requested exemption",
              "Base": "Base",
              "Contrato": "Contract",
              "MecanicoResponsavel": "Responsible mechanic",
              "Cliente": "Client",
              "Observacoes": "Comments",
              "botaoEditarRelatorioDeVoo": "Edit flight report"
          },
          "excluirTripulante": "Are you sure you want to delete this crew member? It will be deleted from all legs.",
          "tituloCadastrarTripulacao": "Register crew",
          "formularioCadastrarTripulacao": {
              "Tripulante": "Crew member",
              "FuncaoDeBordo": "On-board function",
              "DataDeApresentacao": "Start duty date",
              "HoraDeApresentacao": "Start duty time",
              "botaoAdicionarTripulante": "Add crew member"
          },
          "modalEditarTripulacao": {
            "Titulo": "Edit",
            "FuncaoDeBordo": "On-board function",
            "DataDeApresentacao": "Start duty date",
            "HoraDeApresentacao": "Start duty time",
            "botaoEditarTripulante": "Edit crew member",
        },
          "tituloTripulantesCadastrados": "Registered crew",
          "tabelaTripulantesCadastrados": {
              "Nome": "Name",
              "CANAC": "CANAC",
              "SISPAT": "SISPAT",
              "FB": "FB",
              "Apresentacao": "Presentation",
              "DecolagemPouso": "Takeoff/Landing",
              "TempoTotal": "Total time",
              "Navegacao": "Navigation",
              "Instrumento": "Instrument",
              "Noturno": "Night",
              "PousosDiurnos": "Day Landings",
              "PousosNoturnos": "Night Landings",
              "Pax": "Pax.",
              "Carga": "Payload",
              "Consumo": "Consumption",
              "LongLine": "Long line",
              "ShortLine": "Short line",
              "Acoes": "Actions"
          },
          "tituloCadastrarTrecho": "Register leg",
          "botaoSalvarTodos": "Edit all legs",
          "formularioCadastrarTrecho": {
              "Origem": "From",
              "Destino": "To",
              "Partida": "Start",
              "DEC": "Takeoff",
              "POU": "Landing",
              "Corte": "Shutdown",
              "DECPOU": "Tkof-Land",
              "Total": "Total",
              "Nav": "Nav.",
              "IFR": "IFR",
              "Noturno": "Night",
              "Diurnos": "Day",
              "Noturnos": "Night",
              "Partidas": "Starts",
              "PAX": "PAX",
              "Carga": "Payload",
              "LongLine": "Long line",
              "ShortLine": "ShortLine",
              "Inicial": "Initial",
              "Final": "Final",
              "CodigoPTBR": "PTBR code",
              "botaoAdicionarTrecho": "Add leg"
          },
          "tabelaCadastrarTrecho": {
              "Realizados": "Performed",
              "Pousos": "Landings",
              "Dados": "Data",
              "CargaExterna": "External load",
              "Combustivel": "Fuel",
              "OperacaoPTBR": "PTBR operation",
              "Acoes": "Actions",
              "Numero": "No.",
              "Origem": "From",
              "Destino": "To",
              "Partida": "Start",
              "DEC": "Takeoff",
              "POU": "Landing",
              "Corte": "Shutdown",
              "DECPOU": "Tkof-Land",
              "Total": "Total",
              "Nav": "Nav.",
              "IFR": "IFR",
              "Noturno": "Night",
              "Diurnos": "Day",
              "Noturnos": "Night",
              "Partidas": "Starts",
              "PAX": "PAX",
              "Carga": "Payload",
              "LongLine": "Long line",
              "ShortLine": "Short line",
              "Inicial": "Initial",
              "Final": "Final",
              "CodigoPTBR": "PTBR code"
          },
          "tituloTotaisDosTrechos": "Legs total",
          "tabelaTotaisDosTrechos": {
              "DecolagemPouso": "Takeoff/Landing",
              "TempoTotal": "Total time",
              "Navegacao": "Navigation",
              "Instrumento": "Instrument",
              "Noturno": "Night",
              "PousosDiurnos": "Day Landings",
              "PousosNoturnos": "Night Landings",
              "Pax": "Pax.",
              "Carga": "Payload",
              "Consumo": "Consumption"
          },
          "excluirTrecho": "Are you sure you want to delete this leg?",
          "removerTripulanteDoTrecho": "Are you sure you'd like to remove this crew member from this leg?",
          "formularioEditarTrecho": {
              "Origem": "From",
              "Destino": "To",
              "Partida": "Start",
              "DEC": "Takeoff",
              "POU": "Landing",
              "Corte": "Shutdown",
              "DECPOU": "Tkof-Land",
              "Total": "Total",
              "Nav": "Nav.",
              "IFR": "IFR",
              "Noturno": "Night",
              "Diurnos": "Day",
              "Noturnos": "Night",
              "Partidas": "Starts",
              "PAX": "PAX",
              "Carga": "Payload",
              "LongLine": "Long line",
              "ShortLine": "Short line",
              "Inicial": "Initial",
              "Final": "Final",
              "CodigoPTBR": "PTBR code",
              "botaoEditarTrecho": "Edit leg"
          },
          "tituloTripulacaoCadastrada": "Registered crew",
          "formularioAdicionarTripulante": {
              "Tripulante": "Crew member",
              "FuncaoDeBordo": "On-board function",
              "botaoAdicionarTripulante": "Add crew member"
          },
          "tabelaTripulantes": {
              "Nome": "Name",
              "FuncaoDeBordo": "On-board function",
              "Acoes": "Actions"
          },
          "excluirAbastecimento": "Are you sure you want to delete this refuel?",
          "mensagemDadosAtualizadosComSucesso": "Data updated successfully",
          "tituloCadastrarAbastecimento": "Register refuel",
          "formularioAdicionarAbastecimento": {
              "CombustivelSolicitado": "Fuel Requested (Kg or Lb)",
              "Trecho": "Flight Leg",
              "NumeroDaCE": "EC number",
              "Cia": "Co.",
              "CombustivelAbastecido": "Fuel supplied (L)",
              "botaoAdicionarAbastecimento": "Add refuel"
          },
          "tituloAbastecimentosCadastrados": "Registered supplies",
          "tabelaAbastecimentosCadastrados": {
              "Trecho": "Leg",
              "NumeroDaCE": "EC No.",
              "Cia": "Co.",
              "QuantidadeSolicitada": "Quantity requested",
              "QuantidadeAbastecida": "Quantity supplied",
              "Acoes": "Actions"
          },
          "tituloEditarSolicitacaoDeCombustivel": "Edit fuel request",
          "formularioEditarSolicitacaoDeCombustivel": {
              "CombustivelSolicitado": "Fuel Requested",
              "Trecho": "Flight Leg",
              "NumeroDaCE": "EC number",
              "Cia": "Co.",
              "CombustivelAbastecido": "Fuel supplied (L)",
              "botaoEditarAbastecimento": "Edit refuel"
          },
          "tituloObservacoes": "Comments",
          "formularioEditarObservacoes": {
              "Observacoes": "Comments",
              "botaoEditarObservacoes": "Edit notes"
          },
          "tituloAlertasDoRelatorio": "Report Alerts",
          "tabelaAlertasDoRelatorio": {
              "Mensagem": "Message",
              "Data": "Date"
          },
          "aprovarRelatorio": "Are you sure you want to approve this report?",
          "reabrirRelatorio": "Are you sure you want to reopen this report?",
          "reprovarRelatorio": "Are you sure you want to disapprove this report?",
          "relatorioReabertoGerouImplicacoes": "This report has been reopened! This led to the following implications",
          "tabelaImplicacoes": {
              "Mensagem": "Message",
              "Data": "Date"
          },
          "tituloAprovacoes": "Approvals",
          "botaoReabrirRelatorio": "Reopen report",
          "tabelaAprovacoes": {
              "Tipo": "Type",
              "Tripulante": "Crew member",
              "Aprovacao": "Approval",
              "Acoes": "Actions"
          },
          "tituloJustificativaReprovacao": "Justification for disapproval",
          "formularioReprovacao": {
              "RazaoDaReprovacao": "Reason for disapproval",
              "botaoReprovarRelatorio": "Fail report"
          },
          "tituloLoginDoComandanteNoLDAP": "Commander login in LDAP",
          "formularioLogin": {
              "botaoAcessarSistema": "Access the system",
              "placeholder": {
                  "Email": "Your email",
                  "Senha": "Your password"
              }
          },
          "tituloLogDoRelatorio": "Report log",
          "tabelaLogRelatorio": {
              "Usuario": "User",
              "Acao": "Action",
              "Descricao": "Description",
              "Data": "Date"
          }
      },
      "AdicionarRelatorioDeVooOffline": {
          "titulo": "Register new flight report",
          "formulario": {
              "Data": "Date",
              "Prefixo": "Prefix",
              "Voo": "Flight",
              "NumeroDeVoo": "Flight number",
              "SolicitouIsencao": "Requested exemption",
              "Base": "Base",
              "Contrato": "Contract",
              "MecanicoResponsavel": "Responsible mechanic",
              "Cliente": "Client",
              "Observacoes": "Comments",
              "botaoCriarRelatorioDeVoo": "Create flight report"
          }
      },
      "RelatoriosPendentesDeAprovacao": {
          "aprovar": "Are you sure you want to approve this report?",
          "titulo": "Pending Approval Reports",
          "formulario": {
              "Base": "Base",
              "Status": "Status"
          },
          "botaoAprovar": "Approve",
          "tabela": {
              "Data": "Date",
              "Base": "Base",
              "Aeronave": "Aircraft",
              "Frota": "Fleet",
              "Contrato": "Contract",
              "TipoDeVoo": "Flight Type",
              "NumeroDoVoo": "Flight No.",
              "Status": "Status",
              "Acoes": "Actions"
          }
      },
      "QuantidadeDeVoosPorDia": {
          "titulo": "Number of flights per day",
          "formulario": {
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "Aeronave": "Aircraft",
              "Frota": "Fleet",
              "Base": "Base",
              "Tripulantes": "Crew",
              "TipoDeVoo": "Flight Type",
              "Contrato": "Contract",
              "SomenteAprovados": "Only approved",
              "BaseContratual": "Contract Base"
          },
          "tituloTotaisDaAeronavePorData": "Aircraft totals by date",
          "tabelaTotaisDaAeronavePorData": {
              "Data": "Date",
              "Prefixo": "Prefix",
              "Frota": "Fleet",
              "QuantidadeDeVoos": "Number of Flights",
              "QuantidadeDePousos": "Number of Landings",
              "QuantidadeDeCortes": "Number of Cuts",
              "QuantidadeDePAX": "Amount of PAX"
          },
          "tituloTotaisDaAeronavePorPeriodo": "Aircraft totals by period",
          "tabelaTotaisDaAeronavePorPeriodo": {
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "Prefixo": "Prefix",
              "Frota": "Fleet",
              "QuantidadeDeVoos": "Number of Flights",
              "QuantidadeDePousos": "Number of Landings",
              "QuantidadeDeCortes": "Number of Cuts",
              "QuantidadeDePAX": "Amount of PAX"
          },
          "tituloTotaisDoModeloPorData": "Template Totals by Date",
          "tabelaTotaisDoModeloPorData": {
              "Data": "Date",
              "Frota": "Fleet",
              "QuantidadeDeVoos": "Number of Flights",
              "QuantidadeDePousos": "Number of Landings",
              "QuantidadeDeCortes": "Number of Cuts",
              "QuantidadeDePAX": "Amount of PAX"
          },
          "tituloTotaisDoModeloPorPeriodo": "Model totals by period",
          "tabelaTotaisDoModeloPorPeriodo": {
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "Frota": "Fleet",
              "QuantidadeDeVoos": "Number of Flights",
              "QuantidadeDePousos": "Number of Landings",
              "QuantidadeDeCortes": "Number of Cuts",
              "QuantidadeDePAX": "Amount of PAX"
          },
          "tituloTotalGeralPorData": "Grand Total by date",
          "tabelaTotalGeralPorData": {
              "Data": "Date",
              "QuantidadeDeVoos": "Number of Flights",
              "QuantidadeDePousos": "Number of Landings",
              "QuantidadeDeCortes": "Number of Cuts",
              "QuantidadeDePAX": "Amount of PAX"
          },
          "tituloTotalGeralPorPeriodo": "Grand Total per period",
          "tabelaTotalGeralPorPeriodo": {
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "Base": "Base",
              "QuantidadeDeVoos": "Number of Flights",
              "QuantidadeDePousos": "Number of Landings",
              "QuantidadeDeCortes": "Number of Cuts",
              "QuantidadeDePAX": "Amount of PAX"
          }
      },
      "RelatorioDeOcorrenciasAnormais": {
          "titulo": "Report of Abnormal Occurrences",
          "formulario": {
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "SomenteAprovados": "Only approved",
              "RelatorioDeVoo": "Flight Report",
              "Aeronave": "Aircraft",
              "Frota": "Fleet",
              "placeholder": {
                  "InformeONumeroDoRelatorioDeVoo": "Enter the flight report number"
              }
          },
          "tabela": {
              "Data": "Date",
              "Prefixo": "Prefix",
              "Frota": "Fleet",
              "Base": "Base",
              "TipoDeVoo": "Flight Type",
              "Contrato": "Contract",
              "Cliente": "Client",
              "NumeroRelatorio": "Report No.",
              "NumeroDoVoo": "Flight No.",
              "TipoDeOcorrencia": "Type of Occurrence",
              "DescricaoDaOcorrencia": "Occurrence description",
              "AcaoRequerida": "Required Action",
              "Observacoes": "Comments",
              "Tripulantes": "Crew"
          }
      },
      "ControleDiarioDeUtilizacaoDeAeronavesContratadas": {
          "osCamposDataClienteEBaseSaoObrigatoriosParaExportacaoEmPDF": "The fields Date, Customer and Base are mandatory for PDF export.",
          "titulo": "Daily Control of Use of Contracted Aircraft",
          "formulario": {
              "Data": "Date",
              "SomenteAprovados": "Only approved",
              "Base": "Base",
              "Aeronave": "Aircraft",
              "Contrato": "Contract",
              "Cliente": "Client",
              "BaseContratual": "Contract Base"
          },
          "tabela": {
              "Prefixo": "Prefix",
              "Frota": "Fleet",
              "Contrato": "Contract",
              "CodigoSAP": "SAP code",
              "TempoTotalDeVooNaDataDecolagemAoPouso": "Total Flight Time on Date - Takeoff to Landing",
              "TempoTotalDeVooNoDataPartidaAoCorte": "Total Flight Time on Date - Start to Shutoff",
              "IndisponibilidadesMotivos": "Outages - Reasons",
              "IndisponibilidadesHoras": "Outages - Hours"
          }
      },
      "BoletimDeDisponibilidade": {
          "titulo": "Availability bulletin",
          "formulario": {
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "Contrato": "Contract",
              "SomenteAprovados": "Only approved",
              "BaseContratual": "Contract Base"
          },
          "tabela": {
              "Contrato": "Contract",
              "Prefixo": "Prefix",
              "Data": "Date",
              "TipoDeContrato": "Type of contract",
              "VooDecolagemAoPouso": "Flight - Takeoff to Landing",
              "VooPartidaAoCorte": "Flight - Start to Shutoff",
              "QtdPousos": "Qty. landings",
              "QtdPartidas": "Qty. Departures",
              "VooTotalDecolagemAoPouso": "Total Flight - Takeoff to Landing",
              "DuracaoMediaDeVooDecolagemAoPouso": "Average Flight Duration - Takeoff to Landing",
              "VooTotalPartidaAoCorte": "Total Flight - Start to Shutoff",
              "DuracaoMediaDeVooPartidaAoCorte": "Average Flight Duration - Start to Shutoff",
              "MaximoDeDisponibilidadeContratual": "Maximum Contractual Availability",
              "IndisponibilidadeReal": "Actual Unavailability",
              "IndisponibilidadeContratual": "Contractual Unavailability",
              "DisponibilidadeReal": "Actual Availability",
              "DisponibilidadeContratual": "Contractual Availability",
              "TipoMPRG": "MPRG type",
              "TipoMNPR": "MNPR type",
              "TipoOPS": "OPS type",
              "OcorrenciaAnormal": "Abnormal Occurrence"
          },
          "tituloTotais": "Totals",
          "tabelaTotais": {
              "Contrato": "Contract",
              "Prefixo": "Prefix",
              "TipoDeContrato": "Type of contract",
              "QtdPousos": "Qty. landings",
              "QtdPartidas": "Qty. Departures",
              "VooTotalDecolagemAoPouso": "Total Flight - Takeoff to Landing",
              "VooTotalPartidaAoCorte": "Total Flight - Start to Shutoff",
              "DuracaoMediaDeVooDecolagemAoPouso": "Average Flight Duration - Takeoff to Landing",
              "DuracaoMediaDeVooPartidaAoCorte": "Average Flight Duration - Start to Shutoff",
              "TempoTotalRegistrado": "Total Recorded Time",
              "MaximoDeDisponibilidadeContratual": "Maximum Contractual Availability",
              "IndisponibilidadeReal": "Actual Unavailability",
              "IndisponibilidadeContratual": "Contractual Unavailability",
              "DisponibilidadeReal": "Actual Availability",
              "DisponibilidadeContratual": "Contractual Availability",
              "TipoMPRG": "MPRG type",
              "TipoMNPR": "MNPR type",
              "TipoOPS": "OPS type",
              "OcorrenciaAnormal": "Abnormal Occurrence",
              "PorcentagemIndisponibilidadeReal": "% Actual Unavailability",
              "PorcentagemIndisponibilidadeContratual": "% Contractual Unavailability",
              "PorcentagemDisponibilidadeReal": "% Actual Availability",
              "PorcentagemDisponibilidadeContratual": "% Contractual Availability",
              "PorcentagemTipoMPRG": "% MPRG Type",
              "PorcentagemTipoMNPR": "% MNPR Type",
              "PorcentagemTipoOPS": "% Type OPS",
              "PorcentagemAproveitamentoDecolagemAoPouso": "% Utilization - Takeoff to Landing",
              "PorcentagemAproveitamentoPartidaAoCorte": "% Utilization - Departure to Cut"
          }
      },
      "FichasDeDisponibilidade": {
          "titulo": "Availability sheets",
          "formulario": {
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "Aeronave": "Aircraft",
              "Contrato": "Contract",
              "Base": "Base"
          },
          "tabela": {
              "Prefixo": "Prefix",
              "Contrato": "Contract",
              "InicioDisponibilidadeContratual": "Home disp. contractual",
              "FimDispContratual": "End available contractual",
              "InicioIndisponibilidade": "Indisp.",
              "FimIndisponibilidade": "Indisp. end",
              "Franquia": "Franchise",
              "IndisponibilidadeTotal": "Indisp. Total",
              "SemFranquia": "No deductible",
              "TempoTotal": "Total time"
          }
      },
      "RelatorioDeConsumo": {
          "titulo": "Consumption Report",
          "formulario": {
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "SomenteAprovados": "Only approved",
              "RelatorioDeVoo": "Flight Report",
              "Aeronave": "Aircraft",
              "Frota": "Fleet",
              "Base": "Base",
              "TipoDeVoo": "Flight Type",
              "Contrato": "Contract",
              "Cliente": "Client",
              "NumeroDeReciboDoCombustivel": "Fuel Receipt No.",
              "FornecedorDeCombustivel": "Fuel Supplier",
              "BaseContratual": "Contract Base",
              "placeholder": {
                  "InformeONumeroDoRelatorioDeVoo": "Enter the flight report number"
              }
          },
          "tabela": {
              "Data": "Date",
              "Prefixo": "Prefix",
              "Frota": "Fleet",
              "Base": "Base",
              "TipoDeVoo": "Flight Type",
              "Contrato": "Contract",
              "Cliente": "Client",
              "NumeroRelatorio": "Report No.",
              "NumeroDoVoo": "Flight No.",
              "Isencao": "Exemption",
              "TotalVooDecolagemAoPouso": "Total Flight - Takeoff to Landing",
              "TotalDoVooPartidaAoCorte": "Total Flight - Start to Shutoff",
              "TotalDoVooNavegacao": "Total Flight - Navigation",
              "TotalDoVooInstrumento": "Total Flight - Instrument",
              "TotalDoVooNoturno": "Total Flight - Night",
              "TotalDoVooPartidas": "Total Flight - Departures",
              "TotalDoVooPousosDiurnos": "Total Flight - Day Landings",
              "TotalDoVooPousosNoturnos": "Total Flight - Night Landings",
              "TotalDoVooPAX": "Total Flight - PAX",
              "TotalDoVooCarga": "Total Flight - Cargo",
              "TipoDeContrato": "Type of contract",
              "CombustivelAutorizado": "Authorized Fuel",
              "FornecedorDeCombustivel": "Fuel Supplier",
              "NumeroDaCE": "EC No.",
              "QuantidadeSolicitada": "Quantity Requested",
              "QuantidadeAbastecida": "Quantity Supplied",
              "QuantidadeAbastecidaConvertida": "Quantity Supplied Converted",
              "Saldo": "Balance",
              "Consumo": "Consumption",
              "ConsumoEmLitros": "Consumption in liters"
          },
          "tituloTotais": "Totals",
          "tabelaTotais": {
              "Prefixo": "Prefix",
              "Frota": "Fleet",
              "TotalVooDecolagemAoPouso": "Total Flight - Takeoff to Landing",
              "TotalDoVooPartidaAoCorte": "Total Flight - Start to Shutoff",
              "TotalDoVooNavegacao": "Total Flight - Navigation",
              "TotalDoVooInstrumento": "Total Flight - Instrument",
              "TotalDoVooNoturno": "Total Flight - Night",
              "TotalDoVooPartidas": "Total Flight - Departures",
              "TotalDoVooPousosDiurnos": "Total Flight - Day Landings",
              "TotalDoVooPousosNoturnos": "Total Flight - Night Landings",
              "TotalDoVooPAX": "Total Flight - PAX",
              "TotalDoVooCarga": "Total Flight - Cargo",
              "CombustivelAutorizado": "Authorized Fuel",
              "QuantidadeSolicitada": "Quantity Requested",
              "QuantidadeAbastecida": "Quantity Supplied",
              "QuantidadeAbastecidaConvertida": "Quantity Supplied Converted",
              "Saldo": "Balance",
              "Consumo": "Consumption",
              "ConsumoEmLitros": "Consumption in liters"
          }
      },
      "RelatorioDeDisponibilidadeDeCombustivel": {
          "titulo": "Fuel Availability Report",
          "formulario": {
              "MesInicio": "Start Month",
              "MesTermino": "End Month",
              "Aeronave": "Aircraft",
              "Base": "Base",
              "Cliente": "Client",
              "SomenteAprovados": "Only approved"
          },
          "tabela": {
              "Inicio": "Start",
              "Fim": "End",
              "Aeronave": "Aircraft",
              "Frota": "Fleet",
              "Contrato": "Contract",
              "Cliente": "Client",
              "QuantidadeAbastecida": "Quantity Supplied",
              "QuantidadeAbastecidaConvertida": "Quantity Supplied Converted",
              "Consumo": "Consumption",
              "CAutorizado": "C. Authorized",
              "Saldo": "Balance",
              "HorasTotais": "Total hours",
              "Dias": "Days",
              "MediaDeHorasDeVooPorDia": "Average Flight Hours per Day",
              "MediaDeConsumoPorDia": "Average Consumption per Day",
              "MediaDeConsumoPorHorasDeVoo": "Average Consumption by Flight Hours"
          }
      },
      "ExtratoDeDBEmBloco": {
          "titulo": "Multiple DB extract",
          "formulario": {
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "Aeronave": "Aircraft",
              "Contrato": "Contract",
              "Base": "Base",
              "BasesContratual": "Contract Bases",
              "SomenteAprovados": "Only approved"
          },
          "tabela": {
              "Data": "Date",
              "Prefixo": "Prefix",
              "Frota": "Fleet",
              "Base": "Base",
              "Contrato": "Contract",
              "Cliente": "Client",
              "NumeroRelatorio": "Report No.",
              "NumeroDoVoo": "Flight No."
          }
      },
      "RelatorioDePousosPorLocalidade": {
          "titulo": "Landing Report by Location",
          "formulario": {
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "SomenteAprovados": "Only approved",
              "Local": "Place",
              "RelatorioDeVoo": "Flight Report",
              "Aeronave": "Aircraft",
              "Frota": "Fleet",
              "placeholder": {
                  "InformeONumeroDoRelatorioDeVoo": "Enter the flight report number"
              }
          },
          "tabela": {
              "Data": "Date",
              "Prefixo": "Prefix",
              "Frota": "Fleet",
              "Base": "Base",
              "TipoDeVoo": "Flight Type",
              "Contrato": "Contract",
              "Cliente": "Client",
              "NumeroRelatorio": "Report No.",
              "NumeroDoVoo": "Flight No.",
              "Origem": "From",
              "Destino": "To",
              "Tripulantes": "Crew",
              "DEPARR": "DEP-ARR",
              "Total": "Total",
              "TotalDePousosDaAnvNaData": "Total number of ANV landings on the date",
              "TotalDePousosDaAnvNoPeriodo": "Total number of ANV landings in the period",
              "TotalDePousosDaFrotaNoPeriodo": "Total fleet landings in the period",
              "TotalDePousosGeralNoPeriodo": "Total overall landings in the period"
          }
      },
      "ApuracaoDeHoras": {
          "titulo": "Time calculation",
          "formulario": {
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "Aeronave": "Aircraft",
              "BaseContratual": "Contract Base",
              "Contrato": "Contract",
              "Cliente": "Client",
              "Indisponibilidade": "Unavailability",
              "opcoesIndisponibilidade": {
                  "NaoExibir": "Do not display",
                  "ExibirApenasTotal": "Show Only Total",
                  "ExibirApenasContratual": "Show only Contractual",
                  "ExibirTodas": "Show All"
              },
              "SomenteAprovados": "Only approved"
          },
          "tabela": {
              "Data": "Date",
              "Contrato": "Contract",
              "PrefixoContratual": "Contract Prefix",
              "Backup": "Backup",
              "NumeroDoRelatorioDeVoo": "Flight Report No.",
              "NumeroDoVoo": "Flight No.",
              "TipoDeContrato": "Type of contract",
              "TempoTotalDeVooDecolagemAoPouso": "Total Flight Time - Takeoff to Landing",
              "TempoTotalDeVooPartidaAoCorte": "Total Flight Time - Start to Shutoff",
              "CombustivelConsumido": "Fuel consumed",
              "CombustivelAbastecido": "Fuel supplied",
              "IndisponibilidadeDiariaTotal": "Daily Unavailability - Total",
              "IndisponibilidadeDiariaContratual": "Daily Unavailability - Contractual"
          }
      },
      "RelatorioDeTempoEmSolo": {
          "titulo": "Ground Time Report",
          "formulario": {
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "SomenteAprovados": "Only approved",
              "Local": "Place",
              "Aeronave": "Aircraft",
              "Frota": "Fleet"
          },
          "tabela": {
              "Data": "Date",
              "Prefixo": "Prefix",
              "Frota": "Fleet",
              "Base": "Base",
              "TipoDeVoo": "Flight Type",
              "Contrato": "Contract",
              "Cliente": "Client",
              "NumeroRelatorio": "Report No.",
              "NumeroDoVoo": "Flight No.",
              "Origem": "From",
              "Destino": "To",
              "Tripulantes": "Crew",
              "DEPARR": "DEP-ARR",
              "Total": "Total"
          }
      },
      "RelatorioDeTempoEntreTrechos": {
          "titulo": "Time Report between Legs",
          "formulario": {
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "SomenteAprovados": "Only approved",
              "RelatorioDeVoo": "Flight Report",
              "Aeronave": "Aircraft",
              "Frota": "Fleet",
              "placeholder": {
                  "InformeONumeroDoRelatorioDeVoo": "Enter the flight report number"
              }
          },
          "tabela": {
              "Data": "Date",
              "Prefixo": "Prefix",
              "Frota": "Fleet",
              "Base": "Base",
              "TipoDeVoo": "Flight Type",
              "Contrato": "Contract",
              "Cliente": "Client",
              "NumeroRelatorio": "Report No.",
              "NumeroDoVoo": "Flight No.",
              "Tripulantes": "Crew",
              "QuantidadeDeTrechos": "Number of sections",
              "TempoEntreTrechos": "Time between legs",
              "TotalDoVooDEPARR": "Total Flight - DEP-ARR",
              "TotalDoVooTempoTotal": "Total Flight - Total Time"
          }
      },
      "ControleGeralDeRelatorios": {
          "titulo": "General Control of Reports",
          "formulario": {
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "AnaliticoOuSintetico": "Analytical or Synthetic",
              "opcoesAnaliticoOuSintetico": {
                  "AnaliticoPorTripulante": "Analytics - Per Crew",
                  "AnaliticoPorRelatorio": "Analytics - Per Report",
                  "Sintetico": "Synthetic"
              },
              "SomenteAprovados": "Only approved",
              "RelatorioDeVoo": "Flight Report",
              "NumeroDoVoo": "Flight No.",
              "Aeronave": "Aircraft",
              "Frota": "Fleet",
              "Base": "Base",
              "TipoDeVoo": "Flight Type",
              "Contrato": "Contract",
              "Isencao": "Exemption",
              "CargaExterna": "External load",
              "Cliente": "Client",
              "BasesContratual": "Contract Bases",
              "placeholder": {
                  "InformeONumeroDoRelatorioDeVoo": "Enter the flight report number",
                  "InformeONumeroDoVoo": "Enter the flight number"
              }
          },
          "tabela": {
              "Data": "Date",
              "Prefixo": "Prefix",
              "Frota": "Fleet",
              "Base": "Base",
              "TipoDeVoo": "Flight Type",
              "Contrato": "Contract",
              "Cliente": "Client",
              "NumeroRelatorio": "Report No.",
              "NumeroDoVoo": "Flight No.",
              "Isencao": "Exemption",
              "TotalDoVooDEPARR": "Total Flight - DEP-ARR",
              "TotalDoVooTempoTotal": "Total Flight - Total Time",
              "TotalDoVooNavegacao": "Total Flight - Navigation",
              "TotalDoVooInstrumento": "Total Flight - Instrument",
              "TotalDoVooNoturno": "Total Flight - Night",
              "TotalDoVooPousosDiurnos": "Total Flight - Day Landings",
              "TotalDoVooPousosNoturnos": "Total Flight - Night Landings",
              "TotalDoVooPAX": "Total Flight - PAX",
              "TotalDoVooCarga": "Total Flight - Cargo",
              "TotalDoVooConsumo": "Total Flight - Consumption",
              "QuantidadeAbastecida": "Quantity supplied",
              "Observacoes": "Comments",
              "FB": "FB",
              "Apresentacao": "Presentation",
              "Matricula": "Registration",
              "Tripulante": "Crew member",
              "Etapa": "Stage",
              "Origem": "From",
              "Destino": "To",
              "HrPart": "Hr. part.",
              "DEP": "DEP.",
              "ARR": "ARR.",
              "Corte": "Shutdown",
              "DEPARR": "DEP-ARR",
              "TempoTotal": "Total time",
              "TempoNavegacao": "Weather - Navigation",
              "TempoInstrumento": "Time - Instrument",
              "TempoNoturno": "Weather - Night",
              "PousosDiurnos": "Landings - Daytime",
              "PousosNoturnos": "Landings - Night",
              "Partidas": "Starts",
              "PAX": "PAX.",
              "Carga": "Payload",
              "CargaExternaLongLine": "External Cargo - Long Line",
              "CargaExternaShortLine": "External Load - Short Line",
              "CombustivelInicial": "Fuel - Initial",
              "CombustivelFinal": "Fuel - Final"
          }
      },
      "ExtratoDeRelatorioDeVooEmBloco": {
        "titulo": "Multiple Flight Report Extract",
        "formulario": {
          "DataInicial": "Initial date",
          "DataFinal": "Final date",
          "Aeronave": "Aircraft",
          "Contrato": "Contract",
          "Base": "Base",
          "BasesContratual": "Contract Base",
          "SomenteAprovados": "Only approved",
          "linguagem": "Language",
        },
  
        "tabela": {
          "Data": "Date",
          "Prefixo": "Prefix",
          "Frota": "Fleet",
          "Base": "Base",
          "Contrato": "Contract",
          "Cliente": "Client",
          "NumeroRelatorio": "Report No.",
          "NumeroDoVoo": "Flight No."
        }
  
      },
      "ConferenciaDeMedicao": {
          "titulo": "Measurement conference",
          "formulario": {
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "Contrato": "Contract",
              "Cliente": "Client",
              "TipoDeMedicao": "Measurement Type",
              "opcoesMedicao": {
                  "Sintetica": "Synthetic",
                  "Analitica": "Analytics"
              },
              "SomenteAprovados": "Only approved",
              "BaseContratual": "Contract Base"
          },
          "tabela": {
              "Contrato": "Contract",
              "PrefixoContrato": "Contract prefix",
              "Status": "Status",
              "NumeroDoVoo": "Flight No.",
              "Cliente": "Client",
              "CodigoPTBR": "PTBR code",
              "LocalidadeInicio": "Location - start",
              "LocalidadeFim": "Location - end",
              "Prefixo": "Prefix",
              "Inicio": "Start",
              "Fim": "End"
          }
      },
      "RelatorioDeVoosComCargaExterna": {
          "titulo": "Report of Flights with External Cargo",
          "formulario": {
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "SomenteAprovados": "Only approved",
              "RelatorioDeVoo": "Flight Report",
              "Aeronave": "Aircraft",
              "Frota": "Fleet",
              "Tripulantes": "Crew",
              "placeholder": {
                  "InformeONumeroDoRelatorioDeVoo": "Enter the flight report number"
              }
          },
          "tabela": {
              "Data": "Date",
              "Prefixo": "Prefix",
              "Frota": "Fleet",
              "Base": "Base",
              "TipoDeVoo": "Flight Type",
              "Contrato": "Contract",
              "Cliente": "Client",
              "NumeroRelatorio": "Report No.",
              "NumeroDoVoo": "Flight No.",
              "Tripulantes": "Crew",
              "TotalDoVooDEPARR": "Total Flight - DEP-ARR",
              "TotalDoVooTempoTotal": "Total Flight - Total Time",
              "CargaExternaLongLine": "External Cargo - Long Line",
              "CargaExternaShortLine": "External Load - Short Line"
          }
      },
      "RelatorioDePontualidade": {
          "titulo": "Punctuality Report",
          "formulario": {
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "Base": "Base",
              "SomenteAprovados": "Only approved",
              "TipoDeAtraso": "Type of delay",
              "opcoesTiposDeAtraso": {
                  "Decolagem": "Take-off",
                  "TempoDeVoo": "Flight time"
              }
          },
          "tabela": {
            EstatisticasDeVooDe(dataInicial, dataFinal){
              return `Flight statistic from ${dataInicial} to ${dataFinal}`
            },
    
              "Tipo": "Type",
              "Valor": "Value",
              "TempoTotalDeAtraso": "Total Delay Time",
              "Atrasados": "Late",
              "Pontuais": "Punctual",
              "MediaTempo": "Average Time",
              "Operacoes": "Operations",
              "Coordenacao": "Coordination",
              "Despacho": "Dispatch",
              "Manutencao": "Maintenance",
              "NumeroVoos": "Number of flights",
              "AtrasadosInterno": "Int arrears",
              "AtrasadosExterno": "Late Ext",
              "Pontualidade": "Punctuality",
              "PontualidadeSemAtrasoExterno": "Pont (w/o ext delays)",
              "PontualidadeSemAtrasoInterno": "Pont (w/o int delays)",
              "VooManutencao": "Flight Maintenance",
              "VooGiros": "Flight Tours",
              "VooTreinamento": "Flight Training",
              "VooPTBR": "PTBR flight",
              "VooOutrosClientes": "Flight Other Clients",
              "VoosComerciais": "Commercial Flights"
          }
      },
      "RelatorioDeAbastecimentos": {
          "titulo": "Supply Report",
          "formulario": {
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "SomenteAprovados": "Only approved",
              "RelatorioDeVoo": "Flight Report",
              "Aeronave": "Aircraft",
              "Frota": "Fleet",
              "Base": "Base",
              "TipoDeVoo": "Flight Type",
              "Contrato": "Contract",
              "NumeroDeReciboDoCombustivel": "Fuel Receipt No.",
              "FornecedorDeCombustivel": "Fuel Supplier",
              "placeholder": {
                  "InformeONumeroDoRelatorioDeVoo": "Enter the flight report number",
                  "InformeONumeroDeReciboDoCombustivel": "Enter fuel receipt number",
              }
          },
          "tabela": {
              "ID": "ID",
              "Data": "Date",
              "Aeronave": "Aircraft",
              "Modelo": "Model",
              "NumeroRelatorioDeVoo": "Flight Report No.",
              "TipoDeVoo": "Flight Type",
              "FornecedorDeCombustivel": "Fuel Supplier",
              "NumeroDoRecibo": "Receipt No.",
              "QuantidadeDeCombustivel": "Amount of Fuel"
          }
      },
      "ExtracaoDeXMLEmBloco": {
          "titulo": "Multiple XML extraction",
          "formulario": {
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "Aeronave": "Aircraft",
              "Cliente": "Client",
              "Contrato": "Contract",
              "Base": "Base",
              "SomenteAprovados": "Only approved",
              "BaseContratual": "Contract Base"
          },
          "tabela": {
              "Data": "Date",
              "Prefixo": "Prefix",
              "Frota": "Fleet",
              "Base": "Base",
              "Contrato": "Contract",
              "Cliente": "Client",
              "NumeroRelatorio": "Report No.",
              "NumeroDoVoo": "Flight No."
          }
      }
  },
  "Layout": {
      "Topo": {
          "bemvindo": "Welcome,",
          "botaoMinhaConta": "My account",
          "botaoSair": "Logout",
          "menuDadosBasicos": {
              "tituloMenu": "Basic data",
              "FileDigital": "Digital file"
          },
          "menuVoos": {
              "tituloMenu": "Flights",
              "Abastecimentos": "Refuel",
              "ListaDeAbastecimentos": "Refuels list",
              "CadastrarAbastecimentoAvulso": "Register refuel",
              "Relatorios": "Reports",
              "ListaDeRelatoriosDeVoo": "Flight report list",
              "CadastrarRelatorioDeVoo": "Register flight report",
              "ListaDeRelatoriosDeVooOffline": "Offline flight report list",
              "Controle": "Control",
              "VisualizarHoraDeVoo": "View flight time",
              "ControleGeralDeRelatorios": "General Control of Reports",
              "ExtratoDeDBEmBloco": "Multiple DB extract",
              "ExtratoDeRelatoriosEmBloco": "Multiple Report Extract"
          },
          "menuEscalas": {
              "tituloMenu": "Schedules",
              "EscalasDeMissao": "Mission Schedules",
              "EscalaDeMissao": "Mission Schedule",
              "SolicitacoesDeEscala": "Escalation Requests",
              "CadastrarSolicitacao": "Register Request",
              "ListaDeSolicitacoes": "List of Requests",
              "EscalaDiaria": "Daily schedule",
              "ListaDeEscalasDiaria": "List of daily schedule"
          },
          "menuTreinamentos": {
              "tituloMenu": "Trainings",
              "ComunicadosDeTreinamento": "Training Announcements",
              "ListaDeLogbooks": "List of logbooks"
          },
          "menuPagamentos": {
              "tituloMenu": "Payments",
              "Pagamentos": "Payments",
              "ExtratoPorReferencia": "Extract by Reference",
              "ExtratoPorPagamento": "Statement by Payment",
              "SolicitacoesDePagamento": "Payment Requests",
              "DeslocamentoDeMissao": "Mission Shift",
              "DeslocamentoDeTreinamento": "Training Displacement",
              "TransporteDeMissao": "Mission Transport",
              "TransporteDeTreinamento": "Training Transport"
          },
          "menuFIRA": {
              "tituloMenu": "FIRA",
              "PapeletasIndividuaisFIRA": "Individual pilot logbooks (FIRA)",
              "ListaDePapeletas": "List of Pilot Logbooks",
              "Consulta": "Query",
              "ControleDeFIRA": "FIRA control"
          },
          "menuFRMS": {
              "tituloMenu": "FRMS",
              "AdicionarDiscrepancia": "Discrepância técnica",
              "RelatoriosDeFadiga": "Fatigue reports",
              "ListaDeRelatoriosDeFadigas": "Fatigue report list",
              "CadastrarRelatoriosDeFadiga": "Register fatigue reports",
              "ReporteVoluntarioDeFadiga": "Voluntary fatigue report",
              "ReportarFadiga": "Report fatigue",
              "FerramentaDeAuxilioParaAutoavaliacaoDaFadigaFAPA": "Fatigue Self-Assessment Aid Tool (FAPA)",
              "Cadastrar": "Register"
          },
          "menuPendencias": {
              "OUsuarioNaoPossuiPendencias": "The user has no issues",
              "Documentacao": "Documentation",
              "Papeletas": "Pilot logbooks",
              "Escalas": "Schedules",
              "Voos": "Flights",
              "Treinamentos": "Trainings"
          },
          "menuConfiguracoes": {
              "App": "App",
              "InstalacaoMobile": "Mobile Installation",
              "Diversos": "Several",
              "LinksUteis": "Useful links"
          },
          "atencaoVoceEstaUtilizandoOAmbienteDeHomologacao": "Attention: You are using the approval environment"
      }
  },
  "Miscelania": {
      "Overlay": {
          "paragrafoCarregando": "Loading..."
      },
      "RequestApi": {
          "seuUsuarioNaoTemPermissaoParaAcessarEstaPagina": "Your username does not have permission to access this page.",
          "seuUsuarioNaoTemPermissaoParaAcessarEstaFuncionalidade": "Your user does not have permission to access this functionality."
      }
  },
  "Pagamentos": {
      "Bases": {
          "botaoLocalidades": "Places",
          "titulo": "Bases",
          "tabela": {
              "Nome": "Name",
              "Tipo": "Type",
              "CEP": "Zip code",
              "Base": "Base",
              "botaoAssociarCEPAOrigem": "Associate zip code to origin",
              "botaoAssociarCEPADestino": "Associate zip code to destination",
              "Fornecedor": "Provider"
          }
      },
      "AdicionarSolicitacaoDePagamentoMissaoDeslocamento": {
          "titulo": "Add payment request - mission - displacement",
          "formulario": {
              "EscalaGrade": "Schedule / Grid",
              "Quantidade": "The amount",
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "Valor": "Value",
              "Moeda": "Coin",
              "ValorTotal": "Amount",
              "Observacao": "Observation",
              "tituloTrechos": "Parts",
              "botaoAdicionarTrecho": "Add Leg",
              "tabela": {
                  "BuscarLocais": "Search Locations",
                  "BaseOrigem": "Base Origin",
                  "FornecedorOrigem": "Origin Supplier",
                  "CEPOrigem": "CEP Origin",
                  "BaseDestino": "Destination Base",
                  "FornecedorDestino": "Destination Supplier",
                  "CEPDestino": "CEP Destination"
              },
              "botaoCalcular": "Calculate",
              "botaoSalvarSolicitacao": "Save request",
              "placeholder": {
                  "SelecionarEscala": "Select schedule",
                  "SelecionarMoeda": "Select currency",
                  "Observacao": "Observation"
              }
          }
      },
      "SolicitacoesDePagamentoDeslocamentoMissao": {
          "deletar": "Are you sure you would like to delete this request?",
          "titulo": "Payment Requests - Displacement - Mission",
          "botaoSolicitarPagamentoDeDeslocamentoMissao": "Request travel payment - Mission",
          "tabela": {
              "semSolicitacaoDePagamento": "No payment request registered",
              "ID": "ID",
              "Status": "Status",
              "Lote": "Batch",
              "Frota": "Fleet",
              "Mes": "Month",
              "Revisao": "Revision",
              "Inicio": "Start",
              "Fim": "End",
              "Quantidade": "The amount",
              "Valor": "Value",
              "ValorTotal": "Amount",
              "Moeda": "Coin",
              "Observacao": "Observation",
              "Acoes": "Actions"
          },
          "tituloBases": "Bases",
          "tabelaBases": {
              "Origem": "From",
              "CEPOrigem": "CEP Origin",
              "Destino": "To",
              "CEPDestino": "CEP Destination"
          }
      },
      "AdicionarSolicitacaoDePagamentoMissaoTransporte": {
          "titulo": "Add payment request - mission - transport",
          "formulario": {
              "EscalaGrade": "Schedule / Grid",
              "Quantidade": "The amount",
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "Valor": "Value",
              "Moeda": "Coin",
              "ValorTotal": "Amount",
              "Base": "Base",
              "Observacao": "Observation",
              "botaoSalvarPagamento": "Save payment",
              "placeholder": {
                  "SelecionarEscala": "Select schedule",
                  "SelecionarMoeda": "Select currency",
                  "SelecionarBase": "Select base",
                  "Observacao": "Observation"
              }
          }
      },
      "SolicitacoesDePagamentoTransporteMissao": {
          "deletar": "Are you sure you would like to delete this request?",
          "titulo": "Payment Requests - Transportation - Mission",
          "botaoSolicitarPagamentoDeTransporteMissao": "Request transport payment - Quest",
          "tabela": {
              "semSolicitacaoDePagamento": "No payment request registered",
              "ID": "ID",
              "Status": "Status",
              "Lote": "Batch",
              "Frota": "Fleet",
              "Mes": "Month",
              "Base": "Base",
              "Revisao": "Revision",
              "Quantidade": "The amount",
              "Valor": "Value",
              "Moeda": "Coin",
              "Observaco": "Observation",
              "Acoes": "Actions"
          }
      },
      "AdicionarSolicitacaoDePagamentoTreinamentoDeslocamento": {
          "titulo": "Add payment request - training - shift",
          "formulario": {
              "Treinamento": "Training",
              "Quantidade": "The amount",
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "Valor": "Value",
              "Moeda": "Coin",
              "ValorTotal": "Amount",
              "Observacao": "Observation",
              "placeholder": {
                  "SelecionarTreinamento": "Select training",
                  "SelecionarMoeda": "Select currency",
                  "Observacao": "Observation"
              },
              "tituloTrechos": "Parts",
              "botaoAdicionarTrecho": "Add Leg",
              "tabela": {
                  "BuscarLocais": "Search Locations",
                  "BaseOrigem": "Base Origin",
                  "FornecedorOrigem": "Origin Supplier",
                  "CEPOrigem": "CEP Origin",
                  "BaseDestino": "Destination Base",
                  "FornecedorDestino": "Destination Supplier",
                  "CEPDestino": "CEP Destination"
              },
              "botaoCalcular": "Calculate",
              "botaoSalvarSolicitacao": "Save request"
          }
      },
      "SolicitacoesDePagamentoDeslocamentoTreinamento": {
          "deletar": "Are you sure you would like to delete this request?",
          "titulo": "Payment Requests - Displacement - Training",
          "botaoSolicitarPagamentoDeDeslocamentoTreinamento": "Request travel payment - Training",
          "tabela": {
              "semSolicitacaoDePagamento": "No payment request registered",
              "ID": "ID",
              "Status": "Status",
              "Lote": "Batch",
              "Treinamento": "Training",
              "Revisao": "Revision",
              "Inicio": "Start",
              "Fim": "End",
              "Quantidade": "The amount",
              "Valor": "Value",
              "ValorTotal": "Amount",
              "Moeda": "Coin",
              "Observacao": "Observation",
              "Acoes": "Actions"
          },
          "tituloBases": "Bases",
          "tabelaBases": {
              "Origem": "From",
              "CEPOrigem": "CEP Origin",
              "Destino": "To",
              "CEPDestino": "CEP Destination"
          }
      },
      "AdicionarSolicitacaoDePagamentoTreinamentoTransporte": {
          "titulo": "Add Payment Request - Training - Transport",
          "formulario": {
              "Treinamento": "Training",
              "Quantidade": "The amount",
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "Valor": "Value",
              "Moeda": "Coin",
              "ValorTotal": "Amount",
              "Base": "Base",
              "Observacao": "Observation",
              "botaoSalvarPagamento": "Save payment",
              "placeholder": {
                  "SelecionarTreinamento": "Select training",
                  "SelecionarMoeda": "Select currency",
                  "SelecionarBase": "Select base",
                  "Observacao": "Observation"
              }
          }
      },
      "SolicitacoesDePagamentoTransporteTreinamento": {
          "deletar": "Are you sure you would like to delete this request?",
          "titulo": "Payment Requests - Transportation - Training",
          "botaoSolicitarPagamentoDeTransporteTreinamento": "Request transport payment - Training",
          "tabela": {
              "semSolicitacaoDePagamento": "No payment request registered",
              "ID": "ID",
              "Status": "Status",
              "Lote": "Batch",
              "Treinamento": "Training",
              "Base": "Base",
              "Revisao": "Revision",
              "Quantidade": "The amount",
              "Valor": "Value",
              "Moeda": "Coin",
              "Observacao": "Observation",
              "Acoes": "Actions"
          }
      }
  },
  "Escalas": {
      "ListaDeEscalaDiaria": {
          "botaoDisponivel": "Available",
          "botaoIndisponivel": "Unavailable",
          "deletar": "Are you sure you would like to delete this schedule?",
          "titulo": "Daily roster list",
          "botaoAdicionarProgramacao": "Add schedule",
          "formulario": {
              "botaoMudarData": "Change date"
          },
          "tabela": {
              "semProgramacaoParaHoje": "There is no schedule registered for today",
              "ID": "ID",
              "Base": "Base",
              "Aeronave": "Aircraft",
              "Modelo": "Model",
              "Contrato": "Contract",
              "Disponibilidade": "Availability",
              "ComandanteS": "Commander(s)",
              "CopilotoS": "Copilot(s)",
              "ComissarioS": "Commissioner(s)",
              "Apresentacao": "Presentation",
              "Corte": "Shutdown",
              "Status": "Status",
              "Acoes": "Actions"
          }
      },
      "AdicionarEscalaDiaria": {
          "titulo": "Register daily schedule",
          "formulario": {
              "Data": "Date",
              "Base": "Base",
              "Prefixo": "Prefix",
              "Contrato": "Contract",
              "DesejaImportarTripulacaoDaEscala": "Want to import roster crew",
              "botaoSalvarProgramacao": "Save schedule"
          }
      },
      "EditarEscalaDiaria": {
          "trocarOStatusDaEscala": "Are you sure you would like to change the schedule status?",
          "aprovarEscalaMesmoComAlertasVermelhos": "Are you sure you would like to approve the schedule even with the red flags?",
          "titulo": "Edit daily schedule",
          "tituloEditarEscalaDiariaTripulacaoExtra": "Edit Daily Schedule Extra Crew",
          "botaoProgramacao": {
              "TrocarParaRascunho": "Switch to draft",
              "TrocarParaAprovada": "Change to Approved"
          },
          "botaoAlertas": "Alerts",
          "erros": "The following filling errors prevented the unavailability form from being processed",
          "tituloDisponibilidadeDaAeronave": "Aircraft Availability",
          "formularioDisponibilidadeDaAeronave": {
              "Disponivel": "Available",
              "IndisponivelDesde": "Unavailable since",
              "Razao": "Reason",
              "Previsao": "Prediction",
              "FlightFollowingAnormal": "Flight following abnormal",
              "AnormalDesde": "Abnormal since",
              "InspetorMecanicoResponsavel": "Inspector / Responsible Mechanic",
              "Observacoes": "Comments"
          },
          "tituloCriarGrupo": "Create group",
          "formularioCriarGrupo": {
              "HorarioDeApresentacao": "Presentation Time",
              "HorarioDeTerminoDaJornada": "End of Day Time",
              "Situacao": "Situation",
              "Voos": "Flights",
              "botaoAdicionarGrupo": "Add group"
          },
          "tituloAlertasDeAprovacao": "Approval alerts",
          "tabelaAlertasDeAprovacao": {
              "Mensagem": "Message",
              "Data": "Date"
          },
          "tituloLogDeStatus": "Status log",
          "tabelaLogDeStatus": {
              "Usuario": "User",
              "Acao": "Action",
              "Descricao": "Description",
              "Justificativa": "Justification",
              "Data": "Date"
          },
          "tituloAlertas": "Alerts",
          "formularioAlertas": {
              "Justificativa": "Justification",
              "botaoContinuarAprovacao": "Continue approval"
          },

          tituloGrupoAs(Numero, Inicio, Fim) {
            // Verifico se o Fim é nulo, se for, retorno apenas o Inicio
            if (Fim == null) {
                return `Group ${Numero} - ${Inicio}`
            }
            return `Group ${Numero} - ${Inicio} to ${Fim}`
        },
          
          "deletarTripulante": "Are you sure you want to delete this crew member?",
          "deletarGrupo": "Are you sure you want to delete this group?",
          "formularioGrupo": {
              "HorarioDeApresentacao": "Presentation Time",
              "HorarioDeTerminoDaJornada": "End of Day Time",
              "Situacao": "Situation",
              "botaoEditarGrupo": "Edit group"
          },
          "formularioAdicionarComandante": {
              "Comandante": "Commander"
          },
          "formularioAdicionarCopiloto": {
              "Copiloto": "Co-pilot"
          },
          "formularioAdicionarComissario": {
              "Comissario": "Commissioner"
          },
          "tabelaGrupo": {
              "Tripulante": "Crew member",
              "Funcao": "Occupation"
          }
      },
      "ListaDeEscalas": {
          "botaoRevisao": "Revision",
          "titulo": "List of schedules",
          "botaoAdicionarEscala": "Add schedule",
          "tabela": {
              "semEscalasEsteMes": "There are no schedules registered for this month",
              "ID": "ID",
              "Frota": "Fleet",
              "Base": "Base",
              "Referencia": "Reference",
              "Acoes": "Actions"
          }
      }
  },
  "Configuracoes": {
      "EditarConfiguracoes": {
          "deletarConfiguracao": "Are you sure you would like to delete this configuration?",
          "deletarTarefa": "Are you sure you would like to delete this task?",
          "titulo": "Editing Fatigue Settings",
          "formulario": {
              "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
              "LimiteDePontosZonaVerde": "Point limit - green zone",
              "LimiteDePontosZonaAmarela": "Points limit - yellow zone",
              "LimiteDePontosZonaVermelha": "Point limit - red zone",
              "LimiteDePontosDiario": "Point limit - daily",
              "PontuacaoPorDiaDeFolga": "Score per day off",
              "PontuacaoDiariaMediaParaSimulacao": "Average Daily Score for Simulation",
              "placeholder": {
                  "SelecionarAplicabilidade": "Select applicability"
              }
          },
          "tituloConfiguracoesDePontuacao": "Scoring Settings",
          "tabelaConfiguracoesDePontuacao": {
              "TipoDeColaborador": "Employee Type",
              "Acoes": "Actions"
          },
          "tituloEditarConfiguracao": "Edit configuration",
          "formularioEditarConfiguracao": {
              "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
              "LimiteDePontosZonaVerde": "Point limit - green zone",
              "LimiteDePontosZonaAmarela": "Points limit - yellow zone",
              "LimiteDePontosZonaVermelha": "Point limit - red zone",
              "LimiteDePontosDiario": "Point limit - daily",
              "PontuacaoPorDiaDeFolga": "Score per day off",
              "PontuacaoDiariaMediaParaSimulacao": "Average Daily Score for Simulation",
              "placeholder": {
                  "SelecionarAplicabilidade": "Select applicability"
              }
          },
          "tituloTarefasDeRestricao": "Constraint tasks",
          "formularioTarefasDeRestricao": {
              "Tarefa": "Assignment",
              "LimiteDaRestricao": "Constraint limit",
              "Restricao": "Restriction",
              "botaoCadastrarTarefa": "Register task",
              "placeholder": {
                  "SelecionarAplicabilidade": "Select applicability",
                  "SelecionarLimite": "Select limit",
                  "Restricao": "Restriction"
              }
          },
          "tituloTarefasDaAplicabilidade": "Applicability tasks",
          "tabelaTarefasDaAplicabilidade": {
              "Limite": "Limit",
              "Tarefa": "Assignment",
              "Restricao": "Restriction",
              "Acoes": "Actions"
          }
      }
  },
  "ColaboradoresSigmec": {
      "ComunicadosDeTreinamentos": {
          "botaoComunicado": "Announcement",
          "titulo": "Training Announcements",
          "tabela": {
              "semTreinamentos": "There are no registered trainings",
              "ID": "ID",
              "Nome": "Name",
              "Status": "Status",
              "CodigoDeControle": "Control code",
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "Acoes": "Actions"
          }
      },
      "ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia": {
          "botaoConfirmarPresenca": "RSVP",
          "botaoConfirmarAusencia": "Confirm absence",
          "titulo": "Communications of training pending confirmation of presence/absence",
          "tabela": {
              "semTreinamentos": "There are no registered trainings",
              "ID": "ID",
              "Nome": "Name",
              "Status": "Status",
              "CodigoDeControle": "Control code",
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "Acoes": "Actions"
          }
      },
      "EdicaoDeColaborador": {
          "trocarStatusDoColaborador": "Are you sure you want to change the collaborator's status?",
          "titulo": "Contributor Edit",
          "tabDadosDoColaborador": {
              "tituloTab": "Employee data",
              "formulario": {
                  "tituloInformacoesPessoais": "Personal information",
                  "Nome": "Name",
                  "Email": "Email",
                  "EstadoCivil": "Marital status",
                  "TipoSanguineo": "Blood type",
                  "Telefone1": "Phone 1",
                  "Telefone2": "Phone 2",
                  "DadosBancarios": "Bank data",
                  "Nascimento": "Birth",
                  "PaisNascimento": "Country of birth",
                  "UFNascimento": "State of birth",
                  "CidadeNascimento": "City of birth",
                  "Endereco": "Address",
                  "Numero": "Number",
                  "Complemento": "Complement",
                  "Bairro": "Neighborhood",
                  "Cidade": "City",
                  "UF": "State",
                  "Pais": "Country",
                  "PIS": "PIS",
                  "CEP": "Zip code",
                  "CPF": "CPF",
                  "Identidade": "Identity",
                  "IDUF": "UF ID",
                  "OrgaoDeExpedicao": "Dispatch Body",
                  "IDExpedicao": "Shipping ID",
                  "CarteiraDeTrabalhoUF": "State Employment Card",
                  "CarteiraDeTrabalhoProfissional": "Professional Work Card",
                  "CarteiraDeTrabalhoExpedicao": "Dispatch Work Card",
                  "EscolaFormacao": "School/Training",
                  "Escolaridade": "Education",
                  "ConfidenceUS": "US Confidence",
                  "ExpiracaoConfidenceUS": "US confidence expiration",
                  "ConfidenceEU": "Confidence EU",
                  "ExpiracaoConfidenceEU": "EU confidence expiry",
                  "Passaporte": "Passport",
                  "PassaporteExpiracao": "Passport Expiration",
                  "TituloDeEleitor": "Voter ID",
                  "ZonaDeEleitor": "Voter Zone",
                  "SessaoDeEleitor": "Voter session",
                  "CNHCategoria": "CNH category",
                  "CNH": "Driver's license",
                  "CNHExpiracao": "Expiry driver's license",
                  "Reservista": "Reservist",
                  "ReservistaCategoria": "Reservist category",
                  "CertificadoMilitar": "Military Certificate",
                  "CertificadoMilitarMinisterio": "Ministry Military Certificate",
                  "CertificadoMilitarObservacoes": "Military certificate notes",
                  "VistoAmericano": "American visa",
                  "CREA": "CREA",
                  "CREATitulo": "CREATE title",
                  "CREAExpedicao": "CREATE expedition",
                  "CREAValidade": "CREATE validity",
                  "ASO": "ASO",
                  "Contratacao": "Hiring",
                  "Demissao": "Resignation",
                  "NomeDaMae": "Mother's name",
                  "NomeDoPai": "Father's name",
                  "tituloInformacoesProfissionais": "Professional information",
                  "Licenca": "License",
                  "CANAC": "CANAC",
                  "Matricula": "Registration",
                  "ValorHora": "Hourly rate",
                  "ContratoSISPAT": "SISPAT contract",
                  "CodigoSapiens": "Sapiens Code",
                  "placeholder": {
                      "NomeDoColaborador": "Contributor's name",
                      "EmailDoColaborador": "Collaborator's email",
                      "EstadoCivil": "Marital status",
                      "TipoSanguineo": "Blood type",
                      "TelefoneDoColaborador": "Employee phone",
                      "DadosBancarios": "Bank data",
                      "NascimentoDoColaborador": "Employee's birth",
                      "PaisNascimento": "Country of birth",
                      "SelecioneOUF": "Select the UF",
                      "CidadeNascimento": "City of birth",
                      "EnderecoDoColaborador": "Employee address",
                      "Numero": "Number",
                      "Complemento": "Complement",
                      "BairroDoColaborador": "Employee neighborhood",
                      "CidadeDoColaborador": "Employee's city",
                      "Pais": "Country",
                      "PIS": "PIS",
                      "CEPDoColaborador": "Employee zip code",
                      "CPFDoColaborador": "Employee's CPF",
                      "EstadoDeEmissaoDaID": "ID issuing state",
                      "OrgaoExpeditorDaID": "ID issuing agency",
                      "ExpedicaoDaID": "Issuance of ID",
                      "CarteiraDeTrabalhoUF": "State Employment Card",
                      "CarteiraDeTrabalhoProfissional": "Professional Work Card",
                      "CarteiraDeTrabalhoExpedicao": "Dispatch Work Card",
                      "EscolaFormacao": "School/Training",
                      "Escolaridade": "Education",
                      "NumeroDoCartaoConfidenceAmericano": "American confidence card number",
                      "ValidadeDoCartaoConfidenceAmericano": "Validity of the American confidence card",
                      "NumeroDoCartaoConfidenceEuropeu": "European confidence card number",
                      "ValidadeDoCartaoConfidenceEuropeu": "Validity of the European confidence card",
                      "NumeroDoPassaporte": "Passport No.",
                      "ExpiracaoDoPassaporte": "Passport expiration",
                      "TituloDeEleitor": "Voter ID",
                      "ZonaDeEleitor": "Voter Zone",
                      "SessaoDeEleitor": "Voter session",
                      "CNHCategoria": "CNH category",
                      "NumeroDaCarteiraDeMotorista": "Driver's License No.",
                      "ExpiracaoDaCarteiraDeMotorista": "Expiration of driver's license",
                      "Reservista": "Reservist",
                      "ReservistaCategoria": "Reservist category",
                      "CertificadoMilitar": "Military Certificate",
                      "CertificadoMilitarMinisterio": "Ministry Military Certificate",
                      "CertificadoMilitarObservacoes": "Military certificate notes",
                      "VistoAmericano": "American visa",
                      "CREA": "CREA",
                      "CREATitulo": "CREATE title",
                      "CREAExpedicao": "CREATE expedition",
                      "CREAValidade": "CREATE validity",
                      "ASO": "ASO",
                      "Contratacao": "Hiring",
                      "Demissao": "Resignation",
                      "NomeDaMaeDoColaborador": "Employee's mother's name",
                      "NomeDoPaiDoColaborador": "Employee's father's name",
                      "Licenca": "License",
                      "CANAC": "CANAC",
                      "InscricaoDoColaborador": "Collaborator registration",
                      "ValorHora": "Hourly rate",
                      "ContratoSISPAT": "SISPAT contract",
                      "CodigoSapiens": "Sapiens Code"
                  }
              }
          },
          "tabHabilitacoes": {
              "tituloTab": "Qualifications",
              "opcoesNome": {
                  "AVI": "AVI",
                  "CEL": "CEL",
                  "GMP": "GMP"
              },
              "opcoesTipo": {
                  "SelecionarTipo": "Select type",
                  "CHT": "CHT",
                  "CCT": "CCT"
              },
              "tituloHabilitacoes": "Qualifications",
              "nenhumaHabilitacaoCadastrada": "No registration registered.",
              "tabela": {
                  "Tipo": "Type",
                  "Nome": "Name",
                  "Expedicao": "Expedition",
                  "Vencimento": "Maturity",
                  "Valido": "Valid",
                  "Status": "Status",
                  "Ativo": "Active",
                  "Arquivado": "Filed"
              }
          },
          "tabTarefasDesignadas": {
              "tituloTab": "Assigned tasks",
              "tituloTarefas": "Tasks",
              "nenhumaTarefaCadastrada": "No tasks registered.",
              "tabela": {
                  "Tarefa": "Assignment",
                  "Vencimento": "Maturity",
                  "Valido": "Valid",
                  "Status": "Status",
                  "Ativo": "Active",
                  "Arquivado": "Filed"
              }
          },
          "tabFrotasDesignadas": {
              "tituloTab": "Designated fleets",
              "tituloFrotasDesignadas": "Designated fleets",
              "nenhumaFrotaCadastrada": "No fleet registered.",
              "tabela": {
                  "Aeronave": "Aircraft",
                  "Subtipo": "Subtype",
                  "Vencimento": "Maturity",
                  "Instrucao": "Instruction",
                  "Status": "Status",
                  "Ativo": "Active",
                  "Arquivado": "Filed"
              }
          },
          "tabFrotasObrigatorias": {
              "tituloTab": "Mandatory fleets",
              "tituloFrotasObrigatorias": "Mandatory fleets",
              "nenhumaFrotaCadastrada": "No fleet registered.",
              "tabela": {
                  "Aeronave": "Aircraft",
                  "Subtipo": "Subtype",
                  "Status": "Status",
                  "Ativo": "Active",
                  "Arquivado": "Filed"
              }
          },
          "tabDesignacoes": {
              "tituloTab": "Designations",
              "tituloDesignacoes": "Designations",
              "tabRevisoesDeDesignacoes": {
                  "tituloTab": "Assignment Revisions",
                  "botaoExportacoes": {
                      "ExportarDesignacoes": "Export designations",
                      "Revisao": "Revision",
                      RevisaoArquivo(Numero, Status){
                        return `Revision ${Numero} - ${Status} - File`
                      },
          
                      RevisaoObservacoes(Numero, Status){
                        return `Revision ${Numero} - ${Status} - Observations`
                      }
                  },
                  "nenhumaDesignacaoCadastrada": "No designation registered.",
                  "tituloRevisao": "Revision",
                  "tabela": {
                      "Codigo": "Code",
                      "Designacao": "Designation",
                      "DS": "DS",
                      "CEL": "CEL",
                      "GMP": "GMP",
                      "AVI": "AVI",
                      "ProdutoEspecificacao": "Product/Specification",
                      "LimitacoesObservacoes": "Limitations/Observations",
                      "Acfts": "Acfts.",
                      "Eng": "Eng.",
                      "Comp": "Comp."
                  },
                  "designacoesComProdutoEspecificacaoEscritosManualmente": "Handwritten product/specification designations",
                  "tituloRazaoDeAberturaDaRevisao": "Reason for opening the review",
                  "tituloRazaoNaoDisponivel": "Reason not available",
                  "tituloHabilitacoesDesignadasDestaRevisao": "Designated Qualifications of this revision",
                  "nenhumaHabilitacaoCadastrada": "No registration registered.",
                  "tabelaHabilitacoesDesignadasDestaRevisao": {
                      "Nome": "Name",
                      "Expiração": "Expiration"
                  },
                  "tituloTarefasDesignadasDestaRevisao": "Assigned tasks of this review",
                  "nenhumaTarefaCadastrada": "No tasks registered.",
                  "tabelaTarefasDesignadasDestaRevisao": {
                      "Nome": "Name",
                      "Expiracao": "Expiration"
                  },
                  "tituloFrotasDesignadasDestaRevisao": "Designated fleets of this review",
                  "nenhumaFrotaCadastrada": "No fleet registered.",
                  "tabelaFrotasDesignadasDestaRevisao": {
                      "Nome": "Name",
                      "Expiracao": "Expiration"
                  },
                  "tituloLogDeAcoesManuaisDestaRevisao": "Log of manual actions for this revision",
                  "nenhumaAcaoCadastrada": "No action registered.",
                  "tabelaLogDeAcoesManuaisDestaRevisao": {
                      "Acao": "Action",
                      "Tipo": "Type",
                      "Usuario": "User",
                      "Data": "Date"
                  },
                  "osColaboradorNaoPossuiOsCertificadosListadosAbaixo": "Employees do not have the certificates listed below, required for this designation item"
              }
          },
          "tabExperienciaProfissional": {
              "tituloTab": "Professional experience",
              "titutloExperienciaProfissional": "Professional experience",
              "nenhumaExperienciaProfissionalCadastrada": "No registered professional experience.",
              "tabela": {
                  "DataInicial": "Initial date",
                  "DataFinal": "Final date",
                  "Empresa": "Company",
                  "Funcao": "Occupation",
                  "Status": "Status",
                  "Ativo": "Active",
                  "Arquivado": "Filed"
              }
          },
          "tabProvasDeIdioma": {
              "tituloTab": "Language tests",
              "tituloListaDeProvasDeIdioma": "List of Language Tests",
              "nenhumaProvasDeIdiomaCadastrada": "No language tests registered.",
              "tabela": {
                  "Coeficiente": "Coefficient",
                  "Idioma": "Language",
                  "Emissao": "Issuance",
                  "Vencimento": "Maturity",
                  "Status": "Status",
                  "Ativo": "Active",
                  "Arquivado": "Filed"
              }
          },
          "tabFerias": {
              "tituloTab": "Vacation",
              "tituloFerias": "Vacation",
              "nenhumaFeriasCadastrada": "No holidays registered.",
              "tabela": {
                  "DataInicial": "Initial date",
                  "DataFinal": "Final date",
                  "DireitoAFerias": "Right to vacation",
                  "VencimentoDeFerias": "Vacation expiration",
                  "Status": "Status",
                  "Ativo": "Active",
                  "Arquivado": "Filed"
              }
          },
          "tabFuncoes": {
              "tituloTab": "Functions",
              "tituloFuncoes": "Functions",
              "nenhumaFuncaoCadastrada": "No function registered.",
              "tabela": {
                  "DataInicial": "Initial date",
                  "Funcao": "Occupation",
                  "Status": "Status",
                  "Ativo": "Active",
                  "Arquivado": "Filed"
              }
          },
          "tabBases": {
              "tituloTab": "Bases",
              "tituloBases": "Bases",
              "nenhumaBaseCadastrada": "No base registered.",
              "tabela": {
                  "DataInicial": "Initial date",
                  "Base": "Base",
                  "Status": "Status",
                  "Ativo": "Active",
                  "Arquivado": "Filed"
              }
          },
          "tabNiveisDeCargos": {
              "tituloTab": "Job levels",
              "tituloNiveisDeCargos": "Job levels",
              "nenhumaAeronaveCadastrada": "No aircraft registered.",
              "tabela": {
                  "DataDeAlteracao": "Date of change",
                  "Nivel": "Level",
                  "Motivo": "Reason"
              }
          },
          "tabCargos": {
              "tituloTab": "Roles",
              "tituloCargos": "Roles",
              "nenhumCargoCadastrado": "No jobs registered.",
              "tabela": {
                  "DataInicial": "Initial date",
                  "Cargo": "Role",
                  "CodRubi": "Code Ruby",
                  "Status": "Status",
                  "Ativo": "Active",
                  "Arquivado": "Filed"
              }
          },
          "tabCarimbos": {
              "tituloTab": "Stamps",
              "opcoesCarimbo": {
                  "Circulo": "Circle",
                  "Triangulo": "Triangle",
                  "Quadrado": "Square",
                  "Pentagono": "Pentagon",
                  "Hexagono": "Hexagon"
              },
              "tituloCarimbos": "Stamps",
              "nenhumCarimboCadastrado": "No stamp registered.",
              "tabela": {
                  "DataDeEmissao": "Date of issue",
                  "Funcao": "Occupation",
                  "TipoDeCarimbo": "Stamp type",
                  "Numero": "Number",
                  "Revisao": "Revision",
                  "Observacao": "Observation",
                  "Status": "Status",
                  "Ativo": "Active",
                  "Arquivado": "Filed"
              }
          },
          "tabTreinamentos": {
              "tituloTab": "Trainings",
              "tituloCertificados": "Certificates",
              "nenhumCertificadoCadastrado": "No registered certificate",
              "tabela": {
                  "ID": "ID",
                  "Tipo": "Type",
                  "Fim": "End",
                  "Vencimento": "Maturity",
                  "Val": "Val.",
                  "Status": "Status",
                  "Ações": "Actions",
                  "Ativo": "Active",
                  "Arquivado": "Filed"
              }
          },
          "tabNecessidadeDeTreinamentos": {
              "tituloTab": "Training needs",
              "tituloAvaliacaoDeNecessidadeDeTreinamento": "Training need assessment",
              "naoHaFormulariosDeAvaliacao": "There are no training need assessment forms for this employee.",
              "tabela": {
                  "Data": "Date",
                  "MotivoDaAnalise": "Reason for analysis",
                  "OutrasAtividades": "Other activities",
                  "Acoes": "Actions"
              },
              "tituloAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo": "Training need assessment - OLD MODEL",
              "tabelaAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo": {
                  "Conhecimento": "Knowledge",
                  "OutrasAtividades": "Other activities",
                  "Data": "Date",
                  "Acoes": "Actions",
                  "ConhecimentoETreinamento": "Knowledge and Training",
                  "Experiencia": "Experience",
                  "Oficina": "Workshop",
                  "Aeronaves": "Aircraft",
                  "Motores": "Engines",
                  "Inspecao": "Inspection",
                  "Instrucao": "Instruction",
                  "Criacao": "Creation"
              },
              "deletarItem": "Are you sure you would like to delete this item?",
              "tituloEditarNecessidadeDeTreinamento": "Edit training need",
              "formularioEditarNecessidadeDeTreinamento": {
                  "Data": "Date",
                  "MotivoDaAnalise": "Reason for analysis",
                  "opcoesMotivoDaAnalise": {
                      "ContratacaoDoColaborador": "Employee Hiring",
                      "NovaFuncaoDoColaborador": "New Employee Role",
                      "PromocaoDoColaborador": "Employee Promotion",
                      "Outro": "Other"
                  },
                  "PreenchaOMotivo": "Fill in the reason",
                  "OutrasAtividades": "Other activities",
                  "tituloProcedimentosInternos": "Internal procedures",
                  "Integracao": "Integration",
                  "Geral": "General",
                  "SUP": "SUP",
                  "FER": "FER",
                  "MNT": "MNT",
                  "ENG": "ENG",
                  "CTM": "CTM",
                  "SASC": "CASS",
                  "QUA": "WED",
                  "Inspetores": "Inspectors",
                  "Rampa": "Ramp",
                  "tituloApoio": "Support",
                  "Corrosao": "Corrosion",
                  "PBN": "PBN",
                  "HUMSNivel1": "HUMS Level 1",
                  "HUMSNivel2": "HUMS Level 2",
                  "Ingles": "English",
                  "Boroscopia": "Boroscopy",
                  "FatoresHumanos": "Human Factors",
                  "Orientacao": "Guidance",
                  "Pedagogica": "Pedagogical",
                  "ArtigosPerigosos": "Dangerous Goods",
                  "EOS": "EOS"
              },
              "tituloTreinamentosDeProdutos": "Product training",
              "tabelaTreinamentosDeProdutos": {
                  "Aeronaves": "Aircraft",
                  "Motores": "Engines",
                  "Oficinas": "Workshops"
              },
              "tituloConhecimentoTreinamentoEExperienciaAnterior": "Knowledge, Training and Previous Experience",
              "tabelaConhecimentoTreinamentoEExperienciaAnterior": {
                  "Descricao": "Description",
                  "Organizacao": "Organization",
                  "Periodo": "Time course"
              }
          },
          "tabColaboradorReferencia": {
              "tituloTab": "Reference employee",
              "tituloReferencias": "References",
              "nenhumaReferenciaCadastrada": "No reference registered.",
              "tabela": {
                  "Aeronave": "Aircraft",
                  "Referencia": "Reference",
                  "Status": "Status",
                  "Ativo": "Active",
                  "Arquivado": "Filed"
              }
          },
          "tabAfastamentos": {
              "tituloTab": "Removals",
              "tituloAfastamento": "Removal",
              "nenhumaAfastamentoCadastrada": "No recorded leave.",
              "tabela": {
                  "DataInicial": "Initial date",
                  "DataFinal": "Final date",
                  "Motivo": "Reason"
              }
          },
          "tabRegimeDeTrabalho": {
              "tituloTab": "Work regime",
              "tituloRegimeDeTrabalho": "Work regime",
              "nenhumRegimeCadastrado": "No regime registered.",
              "tabela": {
                  "Tipo": "Type",
                  "DataInicial": "Initial date",
                  "Status": "Status",
                  "Ativo": "Active",
                  "Arquivado": "Filed"
              }
          },
          "tabFormacaoAcademica": {
              "tituloTab": "Academic education",
              "opcoesTipoDeFormacao": {
                  "SelecionarTipo": "Select type",
                  "PrimeiroGrau": "1st grade",
                  "SegundoGrau": "2nd degree",
                  "EnsinoSuperior": "University education",
                  "PosGraduacao": "Postgraduate",
                  "MMA": "MMA"
              },
              "tituloFormacaoAcademica": "Academic education",
              "nenhumaFormacaoCadastrada": "No training registered.",
              "tabela": {
                  "Tipo": "Type",
                  "NomeDoCurso": "Course name",
                  "Instituicao": "Institution",
                  "DataDeConclusao": "Date of the conclusion",
                  "Status": "Status",
                  "Ativo": "Active",
                  "Arquivado": "Filed"
              }
          },
          "tabBaseContratual": {
              "tituloTab": "Contract Base",
              "tituloBases": "Bases",
              "nenhumaBaseCadastrada": "No base registered.",
              "tabela": {
                  "Base": "Base"
              }
          }
      }
  },
  "ColaboradoresSigtrip": {
      "ComunicadosDeTreinamentos": {
          "botaoExportar": {
              "Exportar": "Export",
              "Solo": "Ground",
              "SoloTIC": "ICT floor",
              "Simulador": "Simulator",
              "EAD": "EAD"
          },
          "titulo": "Training Announcements",
          "tabela": {
              "semTreinamentos": "There are no registered trainings",
              "ID": "ID",
              "Nome": "Name",
              "Status": "Status",
              "CodigoDeControle": "Control code",
              "TiposDeCertificado": "Certificate types",
              "Modalidade": "Modality",
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "Acoes": "Actions"
          }
      },
      "DocumentosPendentesDeConhecimento": {
          "deletarPapeleta": "Are you sure you would like to delete this pilot logbook?",
          "titulo": "Pending knowledge documents",
          "tituloAListaDeDocumentosPendentesEOriundaDoQPulse": "The list of pending documents comes from Q-Pulse and is updated once a day at 05:00",
          "tabela": {
              "semDocumentosPendentes": "There are no documents pending knowledge",
              "ID": "ID",
              "Matricula": "Registration",
              "Nome": "Name",
              "Documentos": "Documents"
          }
      },
      "ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia": {
          "botaoConfirmarPresenca": "RSVP",
          "botaoConfirmarAusencia": "Confirm absence",
          "titulo": "Communications of training pending confirmation of presence/absence",
          "tabela": {
              "semTreinamentos": "There are no trainings pending confirmation",
              "ID": "ID",
              "Nome": "Name",
              "Status": "Status",
              "CodigoDeControle": "Control code",
              "TiposDeCertificado": "Certificate types",
              "Modalidade": "Modality",
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "Acoes": "Actions"
          }
      },
      "EscalasPendentesDeConhecimento": {
          "botaoRevisao": "Revision",
          "titulo": "Outstanding schedules of knowledge",
          "tabela": {
              "semEscalas": "No pending schedules of knowledge",
              "ID": "ID",
              "Mes": "Month",
              "Base": "Base",
              "Frota": "Fleet",
              "Revisao": "Revision",
              "Status": "Status",
              "Acoes": "Actions"
          }
      },
      "PapeletasPendentesDeAprovacao": {
          "titulo": "Papers pending approval",
          "tabela": {
              "semPapeletas": "There are no papers pending approval",
              "ID": "ID",
              "Nome": "Name",
              "Matricula": "Registration",
              "Referencia": "Reference",
              "Status": "Status",
              "Acoes": "Actions"
          }
      },
      "RelatoriosPendentesDeAprovacao": {
          "titulo": "Reports pending approval",
          "tabela": {
              "semRelatorios": "There are no reports pending approval",
              "ID": "ID",
              "Base": "Base",
              "Data": "Date",
              "Aeronave": "Aircraft",
              "Frota": "Fleet",
              "Cliente": "Client",
              "TipoDeVoo": "Type of flight",
              "NumeroDoRelatorio": "Report number",
              "NumeroDoVoo": "Flight number",
              "Status": "Status",
              "Acoes": "Actions"
          }
      },
      "EditarFuncionario": {
          "titulo": "Employee edit",
          "tabDadosDoFuncionario": {
              "tituloTab": "Employee data",
              "formulario": {
                  "tituloInformacoesPessoais": "Personal information",
                  "Nome": "Name",
                  "Apelido": "Surname",
                  "Telefone1": "Phone 1",
                  "Telefone2": "Phone 2",
                  "EstadoCivil": "Marital status",
                  "Email": "Email",
                  "Naturalidade": "Naturalness",
                  "Escolaridade": "Education",
                  "NomeDaMae": "Mother's name",
                  "NomeDoPai": "Father's name",
                  "Raca": "Race",
                  "DataDeNascimento": "Birth date",
                  "tituloEndereco": "Address",
                  "Endereco": "Address",
                  "Numero": "Number",
                  "Complemento": "Complement",
                  "Bairro": "Neighborhood",
                  "Cidade": "City",
                  "Estado": "State",
                  "Pais": "Country",
                  "CEP": "Zip code",
                  "CPF": "CPF",
                  "Identidade": "Identity",
                  "IdentidadeUF": "Identity - State",
                  "IdentidadeDataDeExpedicao": "Identity - date of issue",
                  "IdentidadeOrgaoExpeditor": "Identity - issuing body",
                  "PIS": "PIS",
                  "ConfidenceUS": "US Confidence",
                  "ExpiracaoConfidenceUS": "US confidence expiration",
                  "ConfidenceEU": "Confidence EU",
                  "ExpiracaoConfidenceEU": "EU confidence expiry",
                  "CTPS": "CTPS",
                  "CTPSNumeroDeSerie": "CTPS - Serial No.",
                  "CTPSExpedicao": "CTPS expedition",
                  "CTPSUF": "CTPS State",
                  "TipoSanguineo": "Blood type",
                  "Matricula": "Registration",
                  "SISPAT": "SISPAT",
                  "CANAC": "CANAC",
                  "Licenca": "License",
                  "Contratacao": "Hiring",
                  "CargoDeAdmissao": "Admission position",
                  "CargoAtual": "Current Position",
                  "EstadoDeNascimento": "Birth state",
                  "CidadeDeNascimento": "City of birth",
                  "PaisDeNascimento": "Country of birth",
                  "ASO": "ASO",
                  "Eletrocardiograma": "Electrocardiogram",
                  "CodigoSapiens": "Sapiens Code"
              }
          },
          "tabAdministrativo": {
              "tituloTab": "Administrative",
              "tituloAdicionarArquivos": "Add files",
              "tabela": {
                  "semArquivos": "There are no registered files",
                  "NomeDoArquivo": "File name",
                  "Tipo": "Type",
                  "Validade": "Shelf life"
              }
          },
          "tabHorasDeVoo": {
              "tituloTab": "Flight hours",
              "tituloTotaisDeHoras": "Total hours",
              "tabelaTotaisDeHoras": {
                  "semAeronaves": "There are no registered aircraft",
                  "ID": "ID",
                  "Modelo": "Model",
                  "FB": "FB",
                  "Total": "Total",
                  "IFR": "IFR.",
                  "Noturno": "Night",
                  "APP": "APP",
                  "Diurno": "Diurnal"
              },
              "tabelaArquivos": {
                  "semArquivos": "There are no registered files",
                  "NomeDoArquivo": "File name",
                  "Validade": "Shelf life"
              }
          },
          "tabHabilitacoes": {
              "tituloTab": "Qualifications",
              "opcoesCodigoDeHabilitacao": {
                  "CCF": "CCF",
                  "CHT": "CHT"
              },
              "opcoesHabilitacao": {
                  "SelecionarTipo": "Select type",
                  "IFRH": "IFRH"
              },
              "tituloHabilitacoes": "Qualifications",
              "botaoEsconderArquivoMorto": "Hide archive",
              "botaoMostrarArquivoMorto": "Show archive",
              "nenhumaHabilitacaoCadastrada": "No registration registered.",
              "tabela": {
                  "Codigo": "Code",
                  "Frota": "Fleet",
                  "Tipo": "Type",
                  "CANAC": "CANAC",
                  "Licenca": "License",
                  "Vencimento": "Maturity",
                  "Status": "Status",
                  "Ativo": "Active",
                  "Arquivado": "Filed"
              }
          },
          "tabProcessos": {
              "tituloTab": "Law Suit",
              "tituloProcessos": "Law Suit",
              "tabela": {
                  "semArquivosDeProcessos": "No process files",
                  "Frota": "Fleet",
                  "Processo": "Process",
                  "Subtipo": "Subtype",
                  "DataDeEmissao": "Date of issue",
                  "Validade": "Shelf life"
              }
          },
          "tabCertificacoes": {
              "tituloTab": "Certifications",
              "tituloCertificados": "Certificates",
              "nenhumCertificadoCadastrado": "No registered certificate.",
              "tabela": {
                  "NomeDoCertificado": "Certificate name",
                  "Inicio": "Start",
                  "Fim": "End",
                  "Vencimento": "Maturity",
                  "Status": "Status",
                  "Arquivo": "Archive",
                  "Ativo": "Active",
                  "Arquivado": "Filed"
              }
          },
          "tabAvaliacoes": {
              "tituloTab": "Assessments",
              "tituloAvaliacoes": "Assessments",
              "nenhumCertificadoCadastrado": "No registered certificate.",
              "tabela": {
                  "NomeDoCertificado": "Certificate name",
                  "Inicio": "Start",
                  "Fim": "End",
                  "Vencimento": "Maturity",
                  "Status": "Status",
                  "Arquivo": "Archive",
                  "Ativo": "Active",
                  "Arquivado": "Filed"
              }
          },
          "tabCargos": {
              "tituloTab": "Roles",
              "tituloCargos": "Roles",
              "nenhumCargoCadastrado": "No jobs registered.",
              "tabela": {
                  "Cargo": "Role",
                  "CodigoRubi": "Code Ruby",
                  "Status": "Status",
                  "Data": "Date",
                  "Ativo": "Active",
                  "Arquivado": "Filed"
              }
          },
          "tabDesignacoes": {
              "tituloTab": "Designations",
              "tituloDesignacoes": "Designations",
              "nenhumaDesignacaoCadastrada": "No designation registered.",
              "tabela": {
                  "Designacao": "Designation",
                  "Frota": "Fleet",
                  "Status": "Status",
                  "Data": "Date",
                  "Ativo": "Active",
                  "Arquivado": "Filed"
              }
          },
          "tabIndicacoes": {
              "tituloTab": "Indications",
              "tituloIndicacao": "Recommendation",
              "nenhumaIndicacaoCadastrada": "No indication registered.",
              "tabela": {
                  "Designacao": "Designation",
                  "Frota": "Fleet",
                  "Status": "Status",
                  "Data": "Date",
                  "Ativo": "Active",
                  "Arquivado": "Filed"
              }
          },
          "tabRegimes": {
              "tituloTab": "Regimes",
              "tituloRegimes": "Regimes",
              "nenhumRegimeCadastrado": "No regime registered.",
              "tabela": {
                  "Regime": "Regime",
                  "Data": "Date",
                  "Mes": "Month",
                  "Ano": "Year",
                  "Status": "Status",
                  "Ativo": "Active",
                  "Arquivado": "Filed"
              }
          },
          "tabGratificacoes": {
              "tituloTab": "Gratuities",
              "tituloGratificacoes": "Gratuities",
              "nenhumaGratificacaoCadastrada": "No bonus registered.",
              "tabela": {
                  "Gratificacao": "Gratification",
                  "Data": "Date",
                  "Status": "Status",
                  "Ativo": "Active",
                  "Arquivado": "Filed"
              }
          },
          "tabAprovacoes": {
              "tituloTab": "Approvals",
              "tituloAprovacoesDeClientes": "Customer Approvals",
              "nenhumaAprovacaoCadastrada": "No registered approval.",
              "tabela": {
                  "Client": "Client",
                  "Grupo": "Group",
                  "Funcao": "Occupation",
                  "Aeronaves": "Aircraft"
              }
          },
          "tabICAO": {
              "tituloTab": "ICAO",
              "tituloICAOS": "ICAOS",
              "nenhumICAOCadastrado": "No ICAO registered.",
              "tabela": {
                  "Level": "Level",
                  "Vencimento": "Maturity",
                  "DataDeInsercao": "Insertion Date",
                  "Status": "Status",
                  "Ativo": "Active",
                  "Arquivado": "Filed"
              }
          },
          "tabBaseContratual": {
              "tituloTab": "Contractual base",
              "tituloBases": "Bases",
              "nenhumaBaseCadastrada": "No base registered.",
              "tabela": {
                  "Base": "Base",
                  "Status": "Status",
                  "Ativo": "Active",
                  "Arquivado": "Filed"
              }
          }
      }
  },
  "Papeletas": {
      "ListaDePapeletas": {
          "deletar": "Are you sure you would like to delete this pilot logbook?",
          "botaoAprovarSelecionados": "Approve Selected",
          "titulo": "List of pilot logbooks",
          "tabela": {
              "semPapeletasPendentes": "There are no outstanding papers",
              "ID": "ID",
              "Nome": "Name",
              "Matricula": "Registration",
              "Referencia": "Reference",
              "Status": "Status",
              "Acoes": "Actions"
          }
      },
      "AdicionarPapeleta": {
          "titulo": "Register pilot logbook",
          "formulario": {
              "MesAno": "Month year",
              "Tripulante": "Crew member"
          }
      },
      "EditarPapeleta": {
          "aguardeEnquantoOArquivoEGerado": "Wait while the file is generated. This process can take a few minutes.",
          "atualizarAsInformacoes": "Are you sure you want to update the information? Changes made in the FIRA will be lost.",
          "titulo": "Slip editing",
          "botaoAtualizar": "To update",
          "botaoAlertas": "Alerts",
          "tituloPendencias": "Pendencies",
          "tabelaPendencias": {
              "Data": "Date",
              "Localidades": "Places",
              "Situacao": "Situation",
              "Horarios": "Schedules",
              "Totais": "Totals",
              "Apresentacao": "Presentation",
              "Liberacao": "Release",
              "InicioDaRefeicao": "Start of Meal",
              "TerminoDaRefeicao": "End of Meal",
              "InicioDaSegundaRefeicao": "Beginning of the Second Meal",
              "TerminoDaSegundaRefeicao": "End of the Second Meal",
              "HorasDeJornada": "Working hours",
              "VooNoturno": "Night flight",
              "VooTotal": "Total Flight",
              "AtualizarAsInformacoesDestaDataDeAcordoComAPendencia": "Are you sure you want to update the information for this date according to the issue? Changes made to the FIRA on this date will be lost.",
              "tituloInterrupcoes": "Interruptions",
              "tabelaInterrupcoes": {
                  "Inicio": "Start",
                  "Fim": "End",
                  "Total": "Total"
              },
              "tituloEquipamentos": "Equipment",
              "tabelaEquipamentos": {
                  "Frota": "Fleet"
              }
          },
          "tituloPapeleta": "Slip",
          "tabelaPapeleta": {
              "Data": "Date",
              "Localidades": "Places",
              "Situacao": "Situation",
              "Horarios": "Schedules",
              "Totais": "Totals",
              "Apresentacao": "Presentation",
              "Liberacao": "Release",
              "ApresentacaoData": "Presentation date",
              "ApresentacaoHora": "Presentation time",
              "InicioDaRefeicaoData": "Meal start date",
              "InicioDaRefeicaoHora": "Meal start time",
              "TerminoDaRefeicaoData": "End of Meal date",
              "TerminoDaRefeicaoHora": "Meal end time",
              "InicioDaSegundaRefeicaoData": "Start of Second Meal date",
              "InicioDaSegundaRefeicaoHora": "Start of Second Meal time",
              "TerminoDaSegundaRefeicaoData": "End of Second Meal date",
              "TerminoDaSegundaRefeicaoHora": "End of Second Meal hour",
              "LiberacaoData": "Release date",
              "Liberacaohora": "Release time",
              "HorasDeJornada": "Working hours",
              "VooNoturno": "Night flight",
              "VooTotal": "Total Flight",
              "DeletarFrota": "Are you sure you want to delete this fleet?",
              "DeletarInterrupcao": "Are you sure you want to delete this interrupt?",
              "AtualizarInformacoesDestaData": "Are you sure you want to update the information for this date? Changes made to the FIRA on this date will be lost.",
              "placeholder": {
                  "SelecionarSituacao": "Select situation"
              },
              "tituloInterrupcoes": "Interruptions",
              "formularioInterrupcoes": {
                  "InicioDaInterrupcao": "Start of interruption",
                  "FimDaInterrupcao": "End of interruption",
                  "botaoAdicionarInterrupcao": "Add interrupt"
              },
              "tabelaInterrupcoes": {
                  "Inicio": "Start",
                  "Fim": "End",
                  "Total": "Total",
                  "Acoes": "Actions"
              },
              "tituloEquipamentos": "Equipment",
              "formularioEquipamentos": {
                  "botaoAdicionarFrota": "Add fleet",
                  "placeholder": {
                      "SelecionarFrota": "Select fleet"
                  }
              },
              "tabelaEquipamentos": {
                  "Frota": "Fleet",
                  "Acoes": "Actions"
              }
          },
          "tituloAlertasDoRelatorio": "Report alerts",
          "tabelaAlertasDoRelatorio": {
              "Mensagem": "Message"
          },
          "tituloAlertas": "Alerts",
          "trocarStatus": "Are you sure you want to change the pilot logbook status?",
          "reabrir": "Are you sure you want to reopen the pilot logbook?",
          "botaoForcarAprovacao": "Force Approval",
          "botaoAprovacaoTripulante": "Approval - Crew",
          "botaoAprovacaoGestor": "Approval - Manager",
          "botaoReabrirPapeleta": "Reopen pilot logbook",
          "botaoPapeletaAprovada": "Approved pilot logbook",
          "erros": "The following filling errors on the indicated days prevented the pilot logbook from being finalized",
          "tituloLogDeAprovacoes": "Approvals log",
          "tabelaLogDeAprovacoes": {
              "Usuario": "User",
              "Acao": "Action",
              "Data": "Date"
          },
          "tituloFIRA": "FIRA",
          "botaoReprovacaoGestor": "Failure - Manager"
      },
      "ListaDePapeletasFinalizadas": {
          "deletar": "Are you sure you would like to delete this pilot logbook?",
          "titulo": "List of completed papers",
          "tabela": {
              "semPapeletasPendentes": "There are no outstanding papers",
              "ID": "ID",
              "Nome": "Name",
              "Matricula": "Registration",
              "Referencia": "Reference",
              "Acoes": "Actions"
          }
      },
      "ListaDePapeletasPendentesGestor": {
          "deletar": "Are you sure you would like to delete this pilot logbook?",
          "titulo": "List of pending pilot logbooks - Manager",
          "tabela": {
              "semPapeletasPendentes": "There are no outstanding papers",
              "ID": "ID",
              "Nome": "Name",
              "Matricula": "Registration",
              "Referencia": "Reference",
              "Acoes": "Actions"
          }
      },
      "ListaDePapeletasPendentesTripulantes": {
          "deletar": "Are you sure you would like to delete this pilot logbook?",
          "titulo": "List of pending pilot logbooks - Crew",
          "tabela": {
              "semPapeletasPendentes": "There are no outstanding papers",
              "ID": "ID",
              "Nome": "Name",
              "Matricula": "Registration",
              "Referencia": "Reference",
              "Acoes": "Actions"
          }
      },
      "ControleDePapeletas": {
          "titulo": "Control of pilot logbooks",
          "formulario": {
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "Nome": "Name",
              "placeholder": {
                  "SelecionarTripulantes": "Select crew"
              }
          },
          "tabela": {
              "Tripulante": "Crew member",
              "SomaDeHorasDeJornada": "Sum of Working Hours",
              "SomaDeHorasDeVooNoturno": "Sum of Night Flight Hours",
              "SomaDeHorasDeVooTotal": "Sum of Total Flight Hours"
          }
      },
      "ConsultaDePapeletas": {
          "titulo": "Consultation of pilot logbooks",
          "formulario": {
              "DataInicial": "Initial date",
              "DataFinal": "Final date"
          },
          "tabela": {
              "MesAno": "Month year",
              "Alertas": "Alerts",
              "Acoes": "Actions"
          }
      },
      "ConsultaDePapeletasGestores": {
          "aguardeEnquantoOArquivoEGerado": "Wait while the file is generated. This process can take a few minutes.",
          "titulo": "Consultation of pilot logbooks - Managers",
          "formulario": {
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "Tripulante": "Crew member",
              "ExibirDesligados": "Show off",
              "SomenteComAlertas": "Only with alerts"
          },
          "tabela": {
              "Tripulante": "Crew member",
              "MesAno": "Month year",
              "Alertas": "Alerts",
              "Acoes": "Actions"
          }
      }
  },
  "RelatoriosDeFadiga": {
      "ListaDeRelatoriosDeFadigas": {
          "botaoAdicionarRelatorioDeFadiga": "Add Fatigue Report",
          "titulo": "Fatigue report list",
          "tabela": {
              "semParametroDeFadiga": "There are no registered fatigue parameters",
              "Data": "Date",
              "Revisao": "Revision",
              "Tripulante": "Crew member",
              "Folga": "Day off",
              "QuantidadeDePontosAtual": "Current amount of points",
              "QuantidadeDePontosReportados": "Number of points reported",
              "Acoes": "Actions"
          }
      },
      "AdicionarRelatorioDeFadiga": {
          noParametroAPontuacaoMaximaFoiUltrapassada(name){
              return `In the parameter ${name} the maximum score was exceeded, confirm sending the report?`
          },
        
          noParametroAPontuacaoMinimaNaoFoiAtingida(name){
              return `In parameter ${name} the minimum score was not reached, confirm sending the report?`
          },
          "titulo": "Register fatigue report",
          "formulario": {
              "Data": "Date",
              "Bases": "Bases",
              "botaoAdicionarRelatorioDeFadiga": "Add Fatigue Report",
              "placeholder": {
                  "SelecionarBase": "Select base",
                  "SelecionarOpcao": "Select option",
                  "Horas": "Hours",
                  "Quantidade": "The amount"
              }
          }
      },
      "EditarRelatorioDeFadiga": {
          noParametroAPontuacaoMaximaFoiUltrapassada(name){
              return `In the parameter ${name} the maximum score was exceeded, confirm sending the report?`
          },
      
          noParametroAPontuacaoMinimaNaoFoiAtingida(name){
              return `In parameter ${name} the minimum score was not reached, confirm sending the report?`
          },
          "titulo": "Fatigue Report Editing - Review",
          "paragrafoStatusDaRevisao": "Review status",
          "paragrafoQuantidadeDePontosAtual": "Current amount of points",
          "paragrafoQuantidadeDePontosReportados": "Number of points reported",
          "tabRevisao": {
              "tituloTab": "Revision",
              "paragrafoStatusDaRevisao": "Review status",
              "paragrafoQuantidadeDePontosAtual": "Current amount of points",
              "paragrafoQuantidadeDePontosReportados": "Number of points reported"
          },
          "tituloCriarRevisao": "Create review",
          "formularioCriarRevisao": {
              "botaoCriarRevisaoDeRelatorioDeFadiga": "Create fatigue report review",
              "placeholder": {
                  "SelecionarOpcao": "Select option",
                  "Horas": "Hours",
                  "Quantidade": "The amount"
              }
          }
      },
      "EditarRelatorioDeFadigaAdministrador": {
          noParametroAPontuacaoMaximaFoiUltrapassada(name){
              return `In the parameter ${name} the maximum score was exceeded, confirm sending the report?`
          },
      
          noParametroAPontuacaoMinimaNaoFoiAtingida(name){
              return `In parameter ${name} the minimum score was not reached, confirm sending the report?`
          },

          "titulo": "Fatigue Report Editing - Review",
          "paragrafoStatusDaRevisao": "Review status",
          "paragrafoQuantidadeDePontosAtual": "Current amount of points",
          "paragrafoQuantidadeDePontosReportados": "Number of points reported",
          "tabRevisao": {
              "tituloTab": "Revision",
              "paragrafoStatusDaRevisao": "Review status",
              "paragrafoQuantidadeDePontosAtual": "Current amount of points",
              "paragrafoQuantidadeDePontosReportados": "Number of points reported"
          },
          "tituloCriarRevisao": "Create review",
          "formularioCriarRevisao": {
              "botaoCriarRevisaoDeRelatorioDeFadiga": "Create fatigue report review",
              "placeholder": {
                  "SelecionarOpcao": "Select option",
                  "Horas": "Hours",
                  "Quantidade": "The amount"
              }
          }
      },
      "AdicionarRelatorioDeFadigaAdministrador": {
          noParametroAPontuacaoMaximaFoiUltrapassada(name){
            return `In the parameter ${name} the maximum score was exceeded, confirm sending the report?`
          },
      
          noParametroAPontuacaoMinimaNaoFoiAtingida(name){
              return `In parameter ${name} the minimum score was not reached, confirm sending the report?`
          },

          "titulo": "Register fatigue report",
          "formulario": {
              "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
              "Tripulantes135": "Crew - 135",
              "Tripulantes121": "Crew - 121",
              "Mecanicos": "Mechanics",
              "Coordenadores": "Coordinators",
              "Data": "Date",
              "Bases": "Bases",
              "botaoAdicionarRelatorioDeFadiga": "Add Fatigue Report",
              "placeholder": {
                  "SelecionarAplicabilidade": "Select applicability",
                  "SelecionarTripulante": "Select crew member",
                  "SelecionarMecanico": "Select mechanic",
                  "SelecionarCoordenador": "Select coordinator",
                  "SelecionarBase": "Select base",
                  "SelecionarOpcao": "Select option",
                  "Horas": "Hours",
                  "Quantidade": "The amount"
              }
          }
      },
      "EditarParametroDeFadiga": {
          "deletar": "Are you sure you would like to delete this option?",
          "titulo": "Edit Fatigue Parameter",
          "formulario": {
              "Nome": "Name",
              "Tipo": "Type",
              "Operador": "Operator",
              "PontosPorHora": "Points per hour",
              "PontosPorQuantidade": "Points per quantity",
              "LimiteDePontos": "Point limit",
              "placeholder": {
                  "NomeDoParametroDeFadiga": "Fatigue parameter name",
                  "SelecionarCliente": "Select customer",
                  "QuantidadeDePontosPorHora": "Number of points per hour",
                  "QuantidadeDePontosPorQuantidade": "Number of points per amount"
              }
          },
          "tituloAdicionarOpcoes": "Add options",
          "formularioAdicionarOpcoes": {
              "Nome": "Name",
              "Pontos": "Spots",
              "placeholder": {
                  "NomeDoParametroDeFadiga": "Fatigue parameter name",
                  "QuantidadeDePontos": "Amount of points"
              }
          },
          "tituloOpcoes": "Options",
          "tabelaOpcoes": {
              "Opcao": "Option",
              "Pontos": "Spots",
              "Acoes": "Actions"
          }
      },
      "SimuladorDeRelatoriosDeFadiga": {
          "titulo": "Fatigue report simulator",
          "formulario": {
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
              "QuantidadeDePontos": "Amount of points",
              "botaoGerarSimulacaoDeRelatoriosDeFadiga": "Generate simulation of fatigue reports",
              "placeholder": {
                  "SelecionarAplicabilidade": "Select applicability"
              }
          },
          "tabDatas": {
              "botaoGerarRelatoriosDeFadiga": "Generate fatigue reports",
              "botaoCopiarParaProximasDatas": "Copy to next dates",
              "formulario": {
                  "MarcarComoFolga": "Mark as day off",
                  "Data": "Date",
                  "placeholder": {
                      "SelecionarOpcao": "Select option",
                      "Horas": "Hours",
                      "Quantidade": "The amount"
                  }
              }
          },
          "tabela": {
              "Data": "Date",
              "Diaria": "Daily",
              "Acumulada": "Accumulated"
          }
      },
      "RevisarHorariosDePonto": {
          "titulo": "Review point schedules",
          "tituloUtilizeEstaFerramentaParaCorrigirOsReportes": "Use this tool to correct reports according to the point API.",
          "tituloAtencaoCasoOReportNaoExistaDeveraSerCriado": "Attention: If the report does not exist, it must be created manually first.",
          "formulario": {
              "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
              "Tripulantes135": "Crew - 135",
              "Tripulantes121": "Crew - 121",
              "Mecanicos": "Mechanics",
              "Coordenadores": "Coordinators",
              "Data": "Date",
              "botaoRevisarHorarios": "Review schedules",
              "placeholder": {
                  "SelecionarAplicabilidade": "Select applicability",
                  "SelecionarTripulante": "Select crew member",
                  "SelecionarMecanico": "Select mechanic",
                  "SelecionarCoordenador": "Select coordinator"
              }
          }
      },
      "FiltroDeRelatorio": {
          "deletar": "Are you sure you'd like to delete this fatigue parameter?",
          "titulo": "Report search",
          "formulario": {
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
              "Mecanicos": "Mechanics",
              "Coordenadores": "Coordinators",
              "Tripulantes": "Crew",
              "Cargos": "Roles",
              "Frotas": "Fleets",
              "Bases": "Bases",
              "ApenasIncidentesDeFadiga": "Just incidents of fatigue",
              "botaoProcurarRelatorios": "Browse reports",
              "placeholder": {
                  "SelecionarAplicabilidade": "Select applicability",
                  "SelecionarMecanicos": "Select Mechanics",
                  "SelecionarCoordenadores": "Select Coordinators",
                  "SelecionarTripulantes": "Select Crew Members",
                  "SelecionarCargos": "Select positions",
                  "SelecionarFrotas": "Select fleets",
                  "SelecionarBases": "Select bases"
              }
          },
          "tituloListaDeRelatoriosDeFadiga": "Fatigue report list",
          "botaoMostrarEsconderTripulantes": "Show/Hide Crewmates",
          "botaoFiltrarTripulantes": "Filter crew",
          "tabela": {
              "Nome": "Name",
              "Pontos": "Spots"
          }
      },
      "RelatorioDeEventosIncidentesDeFadiga": {
          "titulo": "Fatigue Event/Incident Report",
          "formulario": {
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
              "Mecanicos": "Mechanics",
              "Coordenadores": "Coordinators",
              "Tripulantes": "Crew",
              "TipoDeEventoIncidente": "Type of Event/Incident",
              "ApenasIncidentesDeFadigaChecados": "Only fatigue incidents checked",
              "botaoProcurarRelatorios": "Browse reports",
              "placeholder": {
                  "SelecionarAplicabilidade": "Select applicability",
                  "SelecionarMecanicos": "Select Mechanics",
                  "SelecionarCoordenadores": "Select Coordinators",
                  "SelecionarTripulantes": "Select Crew Members",
                  "SelecionarIncidente": "Select incident"
              }
          },
          "tituloListaDeEventosIncidentesDeFadiga": "List of fatigue events/incidents",
          "tabela": {
              "semEventosIncidentesDeFadiga": "There were no fatigue events/incidents in the period",
              "ID": "ID",
              "TipoDeEvento": "Kind of event",
              "Data": "Date",
              "Revisao": "Revision",
              "Tripulante": "Crew member",
              "PontuacaoReportada": "Reported score",
              "PontuacaoTotal": "Total score",
              "Checado": "Checked",
              "DataDaChecagem": "Check Date",
              "AcaoRealizada": "Action Taken",
              "Acoes": "Actions"
          },
          "tituloEditarPlanoDeAcao": "Edit action plan",
          "formularioEditarPlanoDeAcao": {
              "PlanoDeAcao": "Action plan",
              "botaoEditarPlanoDeAcao": "Edit action plan"
          },
          "marcarEsteIncidenteComoChecado": "Are you sure you want to mark this incident as checked?"
      },
      "PesquisaDeRelatoriosNaoPreenchidos": {
          "titulo": "Search for unfilled reports",
          "formulario": {
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
              "Bases": "Bases",
              "IncluirFolgaCadastradaAutomaticamente": "Include automatically registered time off",
              "botaoProcurarRelatorios": "Browse reports",
              "placeholder": {
                  "SelecionarAplicabilidade": "Select applicability",
                  "SelecionarBase": "Select base"
              }
          },
          "tituloListaDeRelatOriosDeFadigasFaltantes": "List of missing fatigue reports",
          "tabela": {
              "semReportesFaltantes": "There are no missing reports in this period",
              "Nome": "Name",
              "Data": "Date",
              "Situacao": "Situation"
          }
      },
      "PesquisaDeRelatorios": {
          "titulo": "Report search",
          "formulario": {
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
              "Mecanicos": "Mechanics",
              "Coordenadores": "Coordinators",
              "Tripulantes": "Crew",
              "Cargos": "Roles",
              "Bases": "Bases",
              "botaoProcurarRelatarios": "Browse reports",
              "placeholder": {
                  "SelecionarAplicabilidade": "Select applicability",
                  "SelecionarMecanicos": "Select Mechanics",
                  "SelecionarCoordenadores": "Select Coordinators",
                  "SelecionarTripulantes": "Select Crew Members",
                  "SelecionarCargos": "Select positions",
                  "SelecionarBases": "Select bases"
              }
          },
          "tituloTotalDoPeriodo": "Period Total",
          "tabelaTotalDoPeriodo": {
              "semParametrosDeFadiga": "There are no registered fatigue parameters",
              "NaoFadigados": "Not fatigued",
              "PontosAzul": "Blue Points",
              "PontosAmarelo": "Yellow Points",
              "PontosVermelho": "Red dots"
          },
          "tituloTotalDiario": "Daily Total",
          "tabelaTotalDiario": {
              "semParametrosDeFadiga": "There are no registered fatigue parameters",
              "Data": "Date",
              "NaoFadigados": "Not fatigued",
              "PontosAzul": "Blue Points",
              "PontosAmarelo": "Yellow Points",
              "PontosVermelho": "Red dots"
          },
          "tituloListaDeRelatoriosDeFadigas": "Fatigue report list",
          "tabelaListaDeRelatoriosDeFadigas": {
              "semParametrosDeFadiga": "There are no registered fatigue parameters",
              "Data": "Date",
              "Revisao": "Revision",
              "Tripulante": "Crew member",
              "Folga": "Day off",
              "QuantidadeDePontosAtual": "Current amount of points",
              "QuantidadeDePontosReportados": "Number of points reported",
              "DiaDePreenchimento": "Filling day",
              "Acoes": "Actions"
          },
          "tituloDadosDoRelatorioDeFadiga": "Fatigue report data",
          "paragrafoQuantidadeDePontosAtual": "Current amount of points",
          "paragrafoQuantidadeDePontosReportados": "Number of points reported",
          "tabelaDadosDoRelatorioDeFadiga": {
              "Parametro": "Parameter",
              "Dados": "Data",
              "Pontos": "Spots"
          }
      }
  },
  "HorasDeVoo": {
      "VisualizarHorasDeVoo": {
          "opcoesTipo": {
              "Sintetica": "Synthetic (Ignores date filter)",
              "Analitica": "Analytics"
          },
          "eNecessarioPreencherDataDeInicioEFimParaPesquisasAnaliticas": "It is necessary to fill in start and end date for analytical searches",
          "titulo": "View flight hours",
          "formulario": {
              "DataInicial": "Initial date",
              "DataFinal": "Final date",
              "FB": "FB",
              "Listagem": "Listing",
              "Modelo": "Model",
              "placeholder": {
                  "SelecionarTipo": "Select type",
                  "SelecionarModelosDeAeronave": "Select aircraft models"
              }
          },
          "tabela": {
              "semAeronaves": "There are no registered aircraft",
              "ID": "ID",
              "Data": "Date",
              "Matricula": "Mat.",
              "Apelido": "Surname",
              "Modelo": "Model",
              "FB": "FB",
              "Simulador": "Simulator",
              "Total": "Total",
              "IFR": "IFR.",
              "Noturno": "Night",
              "APP": "APP",
              "Diu": "Diu",
              "Not": "Not",
              "CgExt": "Cg. Ext."
          },
          "tituloTotais": "Totals",
          "tabelaTotais": {
              "semAeronaves": "There are no registered aircraft",
              "ID": "ID",
              "Matricula": "Mat.",
              "Apelido": "Surname",
              "Modelo": "Model",
              "Total": "Total",
              "IFR": "IFR.",
              "Noturno": "Night",
              "APP": "APP",
              "Diu": "Diu",
              "Not": "Not"
          }
      }
  },
  "Solicitacoes": {
      "ListaDeSolicitacoes": {
          "titulo": "List of Requests",
          "tabela": {
              "semSolicitacoes": "There are no registered requests",
              "ID": "ID",
              "DataDeCriacao": "Creation date",
              "Inicio": "Start",
              "Fim": "End",
              "Justificativa": "Justification",
              "Status": "Status",
              "ChefeDeFrota": "Fleet Chief",
              "ChefeDeFrotaDataResposta": "Chief of Fleet - Response Date",
              "ChefeDeFrotaAprovacao": "Chief of Fleet - Approval",
              "ChefeDeFrotaJustificativa": "Chief of Fleet - Justification",
              "Administrativo": "Administrative",
              "AdministrativoDataResposta": "Administrative - Reply Date",
              "AdministrativoAprovacao": "Administrative - Approval",
              "AdministrativoResposta": "Administrative - Answer"
          }
      },
      "AdicionarSolicitacaoDeAlteracaoDeEscala": {
          "criar": "Are you sure you want to create this request?",
          "titulo": "Register Schedule Change Request",
          "formulario": {
              "Inicio": "Start",
              "Fim": "End",
              "Razao": "Reason"
          }
      },
      "ListaDeSolicitacoesSigmec": {
          "confirmarMudanca": "Are you sure you want to change the status of this request?",
          "titulo": "List of Requests",
          "tabela": {
              "semSolicitacoes": "There are no registered requests",
              "ID": "ID",
              "Escala": "Schedule",
              "Colaborador": "Collaborator",
              "TipoDeSolicitacao": "Request type",
              "Justificativa": "Justification",
              "Status": "Status",
              "Acoes": "Actions"
          },
          "modal": {
              "titulo": "Requisition view",
              "formulario": {
                  "EscalaMesAtual": "Current month schedules",
                  "Atestado": "Certificate",
                  "Colaborador": "Collaborator",
                  "TipoDeAlteracao": "Type of alteration",
                  "Solicitante": "Requester",
                  "DataDeInicio": "Start date",
                  "DataDeTermino": "End date",
                  "Definitiva": "Is the change permanent?",
                  "TempoIndeterminado": "Undetermined time",
                  "Descrição": "Description",
                  "Justificativa": "Justification",
                  "NumeroChamado": "Call No.",
                  "NumeroMp": "Approved MP No.",
                  "Descricao": "Description",
                  "BaseAtual": "Current Base",
                  "NovaBase": "New Base",
                  "FuncaoAtual": "Current Role",
                  "NovaFuncao": "New Function",
                  "QuinzenaAtual": "Current fortnight",
                  "NovaQuinzena": "New fortnight",
                  "PeriodoAtual": "Current Period",
                  "NovaPeriodo": "New Period",
                  "GrupoAtual": "Current Group",
                  "NovoGrupo": "New group"
              },
              "modal_additional": {
                  "Exigencia": "Requirement",
                  "Resposta": "Answer",
                  "botaoEnviarInformacaos": "Send Information",
                  "botaoAprovar": "To approve",
                  "botaoReprovar": "Fail"
              }
          }
      },
      "AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec": {
          "titulo": "Register SIGMEC Schedule Change Request",
          "erros": "The following errors were encountered when trying to request changes",
          "tabela": {
              "EscalaMesAtual": "Current month schedules",
              "Colaborador": "Collaborator",
              "TipoDeAlteracao": "Type of alteration",
              "DataDeInicio": "Start date",
              "DataDeTermino": "End date",
              "Duracao": "Is the change permanent? / Undetermined time",
              "Justificativa": "Justification",
              "Atual": "Current",
              "Novo": "Young",
              "NumeroChamado": "Call No.",
              "NumeroMp": "Approved MP No.",
              "Atestado": "Certificate",
              "Descricao": "Description",
              "Acoes": "Actions"
          },
          "formulario": {
              "placeholder": {
                  "SelecioneEscala": "Select a schedule",
                  "selecioneColaborador": "Select a contributor",
                  "SelecioneTipoDeAlteracao": "Select a change type",
                  "SelecineGrupo": "Select a group",
                  "SelecineQuinzena": "Select a fortnight",
                  "SelecineBase": "Select a base",
                  "SelecinePeriodo": "Select a period",
                  "SelecineFuncao": "Select a role",
                  "NumeroChamado": "Call No.",
                  "NumeroMp": "Approved MP No.",
                  "Atestado": "Certificate"
              },
              "botaoSalvarSolicitacoes": "Add requests",
              "botaoAdicionarSolicitacao": "Add request"
          }
      }
  },
  "Tarefas": {
      "ListaDeTarefas": {
          "titulo": "To-do list",
          "botaoAdicionarTarefa": "Add task",
          "tabela": {
              "semTarefas": "There are no tasks registered",
              "ID": "ID",
              "Nome": "Name",
              "Acoes": "Actions"
          }
      },
      "AdicionarTarefa": {
          "titulo": "Register restriction tasks",
          "formulario": {
              "Tarefa": "Assignment",
              "botaoCadastrarTarefa": "Register task",
              "placeholder": {
                  "TarefaDeRestricao": "Constraint task"
              }
          }
      },
      "EditarTarefa": {
          "titulo": "Edit Constraint Task",
          "formulario": {
              "Tarefa": "Assignment",
              "placeholder": {
                  "TarefaDeRestricao": "Constraint task"
              }
          }
      }
  },
  "Sessoes": {
      "AdicionarSessao": {
          "deletar": "Are you sure you would like to delete this session?",
          "finalizar": "Are you sure you'd like to end this session?",
          "reabrir": "Are you sure you'd like to reopen this session?",
          "osDadosForamAtualizadosComSucesso": "The data has been updated successfully",
          "botaoAberto": "Open",
          "botaoFinalizado": "Finished",
          "botaoConfirmado": "Confirmed",
          "titulo": "Add session",
          "formulario": {
            "Treinamento": "Training",
            "Data": "Date",
            "Inicio": "Start",
            "Fim": "End",
            "Examinador": "Examiner",
            "Instrutor": "Instructor",
            "PilotFlying": "Pilot Flying",
            "PilotMonitoring": "Pilot Monitoring",
    
            "botaoAdicionarSessao": "Add session",
    
            "placeholder": {
              "SelecionarCertificado": "Select Certificates",
              "Data": "Data",
              "HorarioDeInicio": "Start hour",
              "HorarioDeFim": "End hour",
            }
          },
          "tituloListaDeSessoes": "List of sessions",
          "tabela": {
              "semTarefas": "There are no tasks registered",
              "ID": "ID",
              "Treinamento": "Training",
              "Certificado": "Certificate",
              "Inicio": "Start",
              "Fim": "End",
              "HorasTotais": "Total Hours",
              "Arquivo": "Archive",
              "Status": "Status",
              "Acoes": "Actions"
          },
          "importarArquivo": "Are you sure you would like to import this file? When importing, the previous file, if any, will be permanently replaced.",
          "formularioAdicionarArquivo": {
              "placeholder": {
                  "Arquivo": "Archive"
              }
          },
          "opcoesTipo": {
              "Examinador": "Examiner",
              "Instrutor": "Instructor",
              "PilotFlying": "Pilot Flying",
              "PilotMonitoring": "Pilot Monitoring"
          },
          "deletarTripulante": "Are you sure you want to delete this crew member?",
          "tituloAdicionarTripulante": "Add crew member",
          "tabelaTripulantes": {
              "Tripulante": "Crew member",
              "Matricula": "Registration",
              "Tipo": "Type",
              "Acoes": "Actions"
          }
      }
  },
  "LinksUteis": {
      "LinksUteis": {
          "deletar": "Are you sure you would like to delete this link?",
          "titulo": "Useful links",
          "tabela": {
              "semIncompatibilidades": "There are no registered incompatibilities",
              "ID": "ID",
              "Nome": "Name",
              "Link": "Link"
          }
      }
  },
  "Usuarios": {
      "AlteracaoDeSenha": {
          "titulo": "Change password",
          "formulario": {
              "SenhaAtual": "Current password",
              "NovaSenha": "New Password",
              "RepitaANovaSenha": "Repeat the new password",
              "placeholder": {
                  "SenhaAtual": "Current password",
                  "NovaSenha": "New Password",
                  "RepitaANovaSenha": "Repeat the new password"
              }
          }
      },
      "SistemaSuspensoParaManutencao": {
          "titulo": "Suspended system for maintenance",
          "tituloAtualizacao": "Update",
          "paragrafoPrevisaoDeVolta": "Back forecast"
      },
      "RecuperarSenha": {
          "formulario": {
              "botaoRecuperarSenha": "Recover Password",
              "placeholder": {
                  "SeuEmail": "Your email"
              }
          },
          "paragrafoVoltarParaLogin": "Back to login"
      },
      "Login": {
          "usuarioNaoCadastrado": "User not registered. Ask IT to create the user.",
          "usuarioInativo": "Inactive user on this system. Ask IT to release the user.",
          "usuarioSemPermissoes": "User without permissions for this system. Ask IT for access permissions for this user.",
          "usuarioOuSenhaInvalidos": "Username or password is invalid.",
          "paragrafoModuloAdministrativo": "ADMINISTRATIVE MODULE",
          "formulario": {
              "paragrafoAtencao": "ATTENTION: YOU WILL ACCESS THE APPROVAL ENVIRONMENT",
              "botaoAcessarOSistema": "Access the system",
              "placeholder": {
                  "SeuEmail": "Your email",
                  "SuaSenha": "Your password"
              }
          },
          "paragrafoOLoginDeveSerFeitoComUsuarioESenhaOmniRubi": "LOGIN MUST BE DONE WITH THE USERNAME AND PASSWORD OMNI/RUBI",
          "paragrafoEsqueciMinhaSenha": "I forgot my password",
          "paragrafoEntreEmContato": "Please contact IT.",
          "paragrafoPortalDeColaboradores": "EMPLOYEE PORTAL"
      },
      "Questionario": {
          "titulo": "Quiz",
          "formulario": {
              "VoceConcordaQueSeSentiuFadigadoNosUltimosDias": "Do you agree that you have felt fatigued in the last few days?",
              "SelecioneOsFatoresQueContribuiramParaAFadiga": "Select the factors that contributed to the fatigue",
              "opcoesFatoresQueContribuiramParaAFadiga": {
                  "NaoMeSentiFadigado": "I didn't feel fatigued",
                  "DescansoInsuficienteEntreJornadas": "Insufficient rest between shifts",
                  "JornadaInterrompida": "Journey interrupted",
                  "TransicaoDaJornadaDiurnoParaNoturno": "Journey transition (day to night)",
                  "TransicaoDaJornadaNoturnoParaDiurno": "Day transition (night to day)",
                  "HorarioDeInicioDaJornadaDiurno": "Start time of the journey (daytime)",
                  "HorarioDeInicioDaJornadaNoturno": "Start time of the journey (night)",
                  "TrabalhoNoturno": "Night work",
                  "DuracaoDaJornada": "Length of journey",
                  "HoraExtra": "Extra hour",
                  "Transporte": "Transport",
                  "Saude": "Health",
                  "FadigaAcumulada": "Accumulated fatigue",
                  "ProblemasPessoais": "Personal problems"
              },
              "HistoricoDoSonoDosUltimos3Dias": "Sleep History for the last 3 days",
              "QueHorasDormiuNoUltimoDia": "What time did you sleep last day",
              "QueHorasAcordouNoUltimoDia": "What time did you wake up last day",
              "QualidadeDoSonoNoUltimoDia": "Sleep quality on the last day",
              "opcoesSono": {
                  "Otimo": "Excellent",
                  "Bom": "Good",
                  "Normal": "Normal",
                  "Ruim": "Bad",
                  "Pessimo": "Terrible"
              },
              "QueHorasDormiuNoPenultimoDia": "What time did you sleep on the penultimate day",
              "QueHorasAcordouNoPenultimoDia": "What time did you wake up on the penultimate day",
              "QualidadeDoSonoNoPenultimoDia": "Sleep quality on the penultimate day",
              "QueHorasDormiuHa3Dias": "What time did you sleep 3 days ago",
              "QueHorasAcordouHa3Dias": "What time did you wake up 3 days ago",
              "QualidadeDoSonoHa3Dias": "Sleep quality 3 days ago",
              "SinaisFisiologicosECognitivos": "Physiological and cognitive signs",
              "opcoesSinaisFisiologicos": {
                  "NaoMeSentiFadigado": "I didn't feel fatigued",
                  "NenhumSinalFisicoPercebido": "No perceived physical signs",
                  "EsfregarOsOlhosComFrequencia": "Rubbing your eyes frequently",
                  "PiscadasFrequentes": "Frequent blinks",
                  "Bocejo": "Yawn",
                  "OlharFixo": "Stare",
                  "DificuldadeEmManterOsOlhosAbertos": "Difficulty keeping your eyes open",
                  "PiscadasLongas": "Long blinks",
                  "CabeçaBalancandoOuCaindo": "Head shaking or falling",
                  "Inquietacao": "Restlessness"
              },
              "Contramedidas": "Countermeasures",
              "opcoesContramedidas": {
                  "NaoMeSentiFadigado": "I didn't feel fatigued",
                  "AlertouAoColegaSobreORiscoDeFadiga": "Warned the colleague about the risk of fatigue",
                  "AumentouAComunicacao": "Increased communication",
                  "ComidaOuBebida": "Food or drink",
                  "Soneca": "Nap",
                  "CoordenouACargaDeTrabalho": "Coordinated the workload",
                  "Cafeina": "Caffeine"
              },
              "DetalhamentoECausasProvaveis": "Details and probable causes",
              "VoceAcreditaQueOSistemaDeGerenciamentoDeFadigaEEficiente": "Do you believe that the fatigue management system is efficient",
              "Sugestoes": "Suggestions",
              "botaoResponder": "Reply",
              "placeholder": {
                  "SelecionarUmaOpcao": "Select an option",
                  "HorarioDeApresentacao": "Presentation Time",
                  "SelecionarAplicabilidade": "Select applicability",
                  "CasoNaoTenhaSeSentidoFadigadoPreenchaComNA": "If you have not felt fatigued, fill in with N/A"
              }
          }
      },
      "TesteDeSonolencia": {
          "titulo": "Drowsiness test",
          "formulario": {
              "HorarioDeInicioDaJornada": "Start Time of the Day",
              "ComoVoceEstaSeSentindoAgora": "How are you feeling now",
              "opcoesComoVoceEstaSeSentindoAgora": {
                  "ExtremamenteAlerta": "Extremely alert (Extremely alert)",
                  "MuitoAlerta": "Very alert (Very alert)",
                  "Alerta": "Alert",
                  "RazoavelmenteAlerta": "Fairly alert (Reasonably alert)",
                  "NemAlertaNemSonolento": "Neither alert nor sleepy",
                  "AlgunsSinaisDeSonolencia": "Some signs of sleepiness",
                  "SonolentoMasConsigoMeManterAcordado": "Sleepy, but no effort to keep alert",
                  "SonolentoPrecisoMeConcentrarParaMeManterAcordado": "Sleepy, some effort to keep alert",
                  "MuitosonolentoMuitoEsforcoParaMeManterAcordadoLutandoComOSono": "Very sleepy, great effort to keep alert, fighting sleep"
              },
              "botaoResponder": "Reply",
              "placeholder": {
                  "HorarioDeApresentacao": "Presentation Time"
              }
          }
      }
  }
});

export default getLocale;



// WEBPACK FOOTER //
// ./src/i18n/en-US.jsx